//
// Game Controller
//
// The game controller tracks and looks after the current game state, and orchestrates components
// ----------------------------
gameController = {};
gameController.gameLoaded = false;
gameController.dynamicSpinner = true;
gameController.inFreeSpins = false;
gameController.cyclingWins = false;
gameController.spinComplete = false;
gameController.canSlamStop = false;
gameController.slamStopped = false;
gameController.preFSReelPrize = 0;
gameController.inBuyABonus = false;
gameController.inBuyABonusFirstSpin = true;
gameController.magicBet = false;
// gameController.symbolLandAnimator = undefined;
gameController.symbolAdditionalAnimator = undefined;
gameController.platformPaused = false;
gameController.platformPopupActive = false;
gameController.canSkipWin = false;
gameController.inRecovery = false;
gameController.fsWinnings = 0;
gameController._coinFrenzyDelaySlamStop = false;
gameController.currentPersistentState = undefined;
gameController.justHadFreeSpins = false;
gameController.featureType = undefined;
gameController.winAmountSoFar = undefined;
gameController.jackpotWinAmount = undefined;
gameController.meterFullyUpdated = false;

gameController.jackpotTrailCoinScaleTween = undefined;
gameController.jackpotTrailCoinMoveTween = undefined;

gameController.waitingForPigUpdatesToFinish = false;

// Debug: Track coins delivered to each pig
gameController.pigCoinCounts = {
  red: 0,
  blue: 0,
  green: 0,
  gold: 0,
};

// Coin-to-pig position mapping (centered above each pig)
gameController.pigPositions = {
  11: { x: 446, y: -53, scale: 0.33 }, // Red Pig
  12: { x: 610, y: -68, scale: 0.33 }, // Green Pig
  13: { x: 278, y: -86, scale: 0.33 }, // Gold Pig
  14: { x: 806, y: -29, scale: 0.33 }, // Blue Pig
  15: { x: 1070, y: 320, scale: 0.1 }, // Jackpot Mini - Blue
  16: { x: 1070, y: 240, scale: 0.1 }, // Jackpot Minor - Orange
  17: { x: 1060, y: 155, scale: 0.1 }, // Jackpot Maxi - Green
  18: { x: 1060, y: 80, scale: 0.1 }, // Jackpot Major - Purple
  19: { x: 1030, y: -10, scale: 0.1 }, // Jackpot Porker - Gold
  20: { x: 1030, y: -90, scale: 0.1 }, // Jackpot Mega - Red
};

gameController.currentStake = 0;
gameController.previousStake = -1;
gameController.muteCyclingWins = false;
gameController.finalFreeSpin = false;
gameController.totalWinnings = 0;
gameController.gameFullyLoaded = false;
gameController.spinHasWin = 0;
gameController.scatterCount = 0;
gameController.minimumGameTime = undefined;

/////////////////////////////////////////////////////////////////////
// Piggies Prize Party
gameController.freeSpinsData = undefined;
gameController.symbolOverlayDisplay = undefined;
gameController.symbolFrameDisplay = undefined;

gameController.bonusAntipationActive = false;
gameController.featureSkipWinDisplay = false;

gameController.pulseGoldenBetAnim = undefined;

gameController.longSpinReel = gameData.LAST_REEL_INDEX + 1;
gameController.storedLargeSymbols = [];
gameController.bonusTriggeringReels = [];

gameController.anticpationSymbolsAddedThisSpin = false;

gameController.storedPayWinsData = undefined;
gameController.firstEverGame = false;
gameController.bonusWheelVisible = false;
gameController.portraitMode = false;
gameController.mobileMode = false;
gameController.skipWinsPanel = undefined;
gameController.lowWinTimer = undefined;
gameController.currentNonBABStake = 0;
gameController.pigLevels = { green: -1, red: -1, gold: -1, blue: -1 };

gameController.eliminationDisplayLevel = undefined;
gameController.eliminationLevel = undefined;

gameController.freeSpinsDisplayLevel = undefined;
gameController.numFreeSpins = undefined;
gameController.wheelDisplayLevel = undefined;
gameController.jfFreeSpinsDisplayLevel = undefined;

// Game display state tracking
gameController.displayState = null;
/////////////////////////////////////////////////////////////////////

// PERSISTENCE
gameController.persistentValues = {};

gameController.restoreCounters = function (task) {
  let stakeController = resourceManager.getController('stakeController');
  // let initialPlayerState = JSON.parse(task.data.initialPlayerState.state);
  // let playerState = task.data.playerState ? JSON.parse(task.data.playerState.state) : undefined;
  let stake = stakeController.getCurrentStake();
  let mode = gameController.getCurrentMode();
  if (mode === 'BONUS_BUY_LOW' || mode === 'BONUS_BUY_MYSTERY' || mode === 'BONUS_BUY_HIGH') {
    if (gameData.encoreEnabled) {
      mode = 'GOLDENBET_BUY';
    } else {
      mode = 'BASIC';
    }
  }
  // let state = playerState ? playerState : initialPlayerState;
  let stateForModeAndStake = task.data.state[mode]['Stake_' + stake];
  gameController.updateCounters(stateForModeAndStake);
};

gameController.onPersistentValuesUpdate = function (task) {
  // Update the game controller's persistent values with the latest server values
  gameController.persistentValues = task.data.state;

  // Update the current persistent state for the current stake and mode
  let stakeController = resourceManager.getController('stakeController');
  let currentStake = stakeController.getCurrentStake();
  let currentMode = gameController.getCurrentMode();

  // Update the counter state and refresh the UI
  gameController.updateCounterState(currentStake);
  gameController.updateCounters(gameController.getCurrentPersistentStateData(currentStake, currentMode));
};

gameController.onBuyBonusLowActive = function () {
  const fsIndicator = resourceManager.get('mainReelsContainer:redRespin:freeSpinsText');
  fsIndicator.setText(9);
  const goldIndicator = resourceManager.get('mainReelsContainer:goldRespin:goldPigText');
  goldIndicator.renderable = false;
};

gameController.onBuyBonusHighActive = function () {
  const fsIndicator = resourceManager.get('mainReelsContainer:redRespin:freeSpinsText');
  fsIndicator.setText(15);
  const goldIndicator = resourceManager.get('mainReelsContainer:goldRespin:goldPigText');
  goldIndicator.renderable = false;
};

gameController.onBuyBonusMysteryActive = function () {
  const fsIndicator = resourceManager.get('mainReelsContainer:redRespin:freeSpinsText');
  fsIndicator.setText(9);
  const goldIndicator = resourceManager.get('mainReelsContainer:goldRespin:goldPigText');
  goldIndicator.renderable = false;
};

gameController.onUpdatePiggiesBecauseOfForceEvent = function (task) {
  // Update the game controller's persistent values with the latest server values
  // gameController.persistentValues = task.data.state;
  gameController.persistentValues = task.data.initialState;

  // Update the current persistent state for the current stake and mode
  let stakeController = resourceManager.getController('stakeController');
  let currentStake = stakeController.getCurrentStake();
  let currentMode = gameController.getCurrentMode();

  // Update the counter state and refresh the UI
  gameController.updateCounterState(currentStake);
  gameController.updateCounters(gameController.getCurrentPersistentStateData(currentStake, currentMode), true);

  gameController.persistentValues = task.data.state;
  // gameController.updateCounterState(currentStake);
};

gameController.onLayoutComplete = function (task) {
  gameController.firstEverGame = task.data.firstEverGame;
  gameController.minimumGameTime = task.data.minimalSpinningTime;

  gameController.buyBonusCostFreeSpinsHigh = task.data.buyBonusCostFreeSpinsHigh;
  gameController.buyBonusCostFreeSpinsMystery = task.data.buyBonusCostFreeSpinsMystery;
  gameController.buyBonusCostFreeSpinsLow = task.data.buyBonusCostFreeSpinsLow;

  gameController.redRespinParticle = particleManager.createEmitter(
    'megaTrailSmallParticle',
    'mainReelsContainer:redRespin:freeSpinsText',
    0,
    0,
    false
  );
  gameController.redRespinParticle.scale.set(0.7);
  gameController.redRespinParticle.particleEmitter.emit = false;

  gameController.goldRespinParticle = particleManager.createEmitter(
    'porkerTrailSmallParticle',
    'mainReelsContainer:goldRespin:goldPigText',
    0,
    0,
    false
  );
  gameController.goldRespinParticle.scale.set(0.7);
  gameController.goldRespinParticle.particleEmitter.emit = false;

  gameController.greenSpinParticles = [];
  const coords = [
    {
      x: 0, // will never be seen
      y: 0,
    },
    {
      x: -42,
      y: 20,
    },
    {
      x: -19,
      y: 45,
    },
    {
      x: 19,
      y: 45,
    },
    {
      x: 42,
      y: 20,
    },
    {
      x: 49,
      y: -15,
    },
  ];
  for (let i = 0; i < coords.length; i++) {
    const emitter = particleManager.createEmitter(
      'maxiTrailSmallParticle',
      'mainReelsContainer:greenSpinArrow',
      coords[i].x,
      coords[i].y,
      false
    );
    emitter.scale.set(0.5);
    emitter.particleEmitter.emit = false;
    gameController.greenSpinParticles.push(emitter);
  }

  resourceManager.get('stakeChangeContainer').visible = false;

  gameController.gameLoaded = true;
};

gameController.splashScreenComplete = function () {
  musicManager.onSplashScreenComplete();
  gameController.gameFullyLoaded = true;
};

gameController.wheelPrizeScreenShake = function (time) {
  let containerList = [
    resourceManager.get('mainReelsContainer'),
    resourceManager.get('backgroundButtons'),
    resourceManager.get('freeSpinsMeter'),
  ];

  let containerStartPos = [];
  for (let i = 0; i < containerList.length; i++) {
    let startPos = {
      x: containerList[i].position.x,
      y: containerList[i].position.y,
    };
    containerStartPos.push(startPos);
  }

  timerManager.addTimer(
    time,
    function (progress) {
      let xShift = Math.floor(Math.random() * 11) - 5;
      let yShift = Math.floor(Math.random() * 11) - 5;

      for (let i = 0; i < containerList.length; i++) {
        containerList[i].position.x = containerStartPos[i].x + xShift;
        containerList[i].position.y = containerStartPos[i].y + yShift;
      }
    },
    function () {
      for (let i = 0; i < containerList.length; i++) {
        containerList[i].position.x = containerStartPos[i].x;
        containerList[i].position.y = containerStartPos[i].y;
      }
    }
  );
};

gameController.initialise = function () {
  // resourceManager.getContainer('soundTrack').visible = false;

  // Initialize game display state
  if (!gameController.displayState) {
    gameController.displayState = new gameDisplayState();
  }
  gameController.persistentValues = gameData.slotConfig.persistentValues;
  const initialDisplayState = gameData.slotConfig.initialDisplayState;

  gameController.currentPersistentState = gameController.getPersistentValues(gameController.getCurrentModeStake());

  gameController.rng = new RNG();

  resourceManager.get('buttonContainer:buttonBar:autoplayButton:glow').visible = false;

  resourceManager.get('gameBackground:GameBackground').visible = true;

  gameController.jackpotView = resourceManager.getController('jackpotTrailView');
  gameController.freeSpinsController = resourceManager.getController('standardFreeSpinsController');

  gameController.coinFrenzyAnimation = resourceManager.get(
    'mainReelsContainer:coinFrenzyAnimation:CoinFrenzyAnimation'
  );
  // initialise now!!
  gameController.coinFrenzyAnimation.init();

  // resourceManager.get('buttonContainer:buttonBar:autoplayButton:glow').visible = false;

  const volumeButton = resourceManager.get('buttonContainer:buttonBar:mute');
  volumeButton.canShowBase = volumeButton.canShow;
  volumeButton.canShow = function () {
    return this.canShowBase() && settingsMenu.buttons.btnSound.visible;
  };

  gameController.slotMachine = resourceManager.getController('SlotMachine');
  gameController.standardFreeSpinsController = resourceManager.getController('standardFreeSpinsController');

  const reelNames = ['reel0', 'reel1', 'reel2', 'reel3', 'reel4'];
  gameController.slotMachine.subscribeToReelsHitEvent(function (reelId) {
    const reel = reelNames.indexOf(reelId);
    gameController.playLandSounds(reel);
    gameController.onSpinHit(reel);
  });

  gameController.slotMachine.subscribeToReelsLandedEvent(function (reelId) {
    const reel = reelNames.indexOf(reelId);
    gameController.onSpinLand(reel);
  });

  for (let i = 0; i < gameData.numReels; ++i) {
    let rv = resourceManager.get('mainReelsContainer:slotContainer:reelContainer:reel' + i);
    rv.reassignSlotMachine(gameController.slotMachine);
  }

  gameController.slotMachine.selectReelMode('default');

  const slamStopButton = resourceManager.get('buttonContainer:buttonBar:slamStopButton');
  slamStopButton.canEnableBase = slamStopButton.canEnable;
  slamStopButton.canEnable = function () {
    return this.canEnableBase() && gameController._receivedResponse && !gameController._coinFrenzyDelaySlamStop;
  };

  // gameController.symbolLandAnimator = resourceManager.get('mainReelsContainer:slotContainerAnim:BonusLandAnimator');
  gameController.symbolAdditionalAnimator = resourceManager.get(
    'mainReelsContainer:slotContainerAnim:AdditionalAnimator'
  );
  gameController.winControllerMain = resourceManager.getController('WinControllerMain');
  gameController.symbolAnimator = resourceManager.get('mainReelsContainer:slotContainerAnim:SymbolAnimator');
  gameController.symbolAnimatorLow = resourceManager.get('mainReelsContainer:slotContainerAnim:SymbolAnimatorLow');

  // Initialize pig spine animations
  pigSpineController.initialise(initialDisplayState);

  if (gameController.dynamicSpinner) {
    gameController.slotMachine.setDynamicSpinner(true);
    gameController.slotMachine.setInjectorMode('main');
  }

  musicManager.onGameLoaded();

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  gameController.symbolOverlayDisplay = resourceManager.get('mainReelsContainer:symbolOverlayDisplay');
  gameController.symbolFrameDisplay = resourceManager.get('mainReelsContainer:symbolFrameDisplay');
  gameController.fullWinningsDisplay = resourceManager.get('fullWinningsDisplay');
  gameController.cycleWinPanelContainer = resourceManager.get('mainReelsContainer:cycleWinPanelContainer');
  gameController.cycleWinPanel = resourceManager.get('mainReelsContainer:cycleWinPanelContainer:cycleWinPanel');
  gameController.cycleWinLine = resourceManager.get(
    'mainReelsContainer:cycleWinPanelContainer:cycleWinPanel:cycleWinLine'
  );
  gameController.cycleWinSymbol = resourceManager.get(
    'mainReelsContainer:cycleWinPanelContainer:cycleWinPanel:cycleWinSymbol'
  );
  gameController.cycleWinMulti = resourceManager.get(
    'mainReelsContainer:cycleWinPanelContainer:cycleWinPanel:cycleWinMulti'
  );
  gameController.cycleWinValue = resourceManager.get(
    'mainReelsContainer:cycleWinPanelContainer:cycleWinPanel:cycleWinValue'
  );
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  gameController.skipWinsPanel = resourceManager.get('fullScreenSkipButton');

  gameController.cycleWinPanelContainer.visible = false;
  gameController.cycleWinSymbol.gotoAndStop(0);

  // Six Of a Kind
  gameController.reelMaskContainer = resourceManager.get(
    'mainReelsContainer:slotContainer:reelContainer:reelMaskContainer'
  );
  gameController.FiveOfAKindContainer = resourceManager.get('mainReelsContainer:5OfAKindWinContainer');
  gameController.FiveOfAKindText = resourceManager.get('mainReelsContainer:5OfAKindWinContainer:6OfAKindText');

  gameController.FiveOfAKindRay = resourceManager.get('mainReelsContainer:5OfAKindWinContainer:rays');
  gameController.screenDim = resourceManager.get('mainReelsContainer:dimReelsFiveOfAKind');
  const mask1 = new PIXI.Graphics();
  mask1.beginFill(0xff0000);
  //0xff0000
  mask1.drawRect(0, 0, 1, 1);
  mask1.endFill();
  mask1.scale.x = 895;
  mask1.scale.y = 462;

  gameController.reelMaskContainer.addChild(mask1);
  gameController.FiveOfAKindText.mask = mask1;
  gameController.FiveOfAKindRay.mask = mask1;

  gameController.jackpotAssets = {
    jpMega: {
      coin: resourceManager.get('mainReelsContainer:blueRespin:redCoin'),
      panel: resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:megaPanelParent:megaPanel'
      ),
      targetContainer: resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:megaPanelParent:megaPanelCoinTarget'
      ),
      endPosOffsets: { x: 0, y: 0 },
      moveTween: null,
      scaleTween: null,
    },
    jpPorker: {
      coin: resourceManager.get('mainReelsContainer:blueRespin:goldCoin'),
      panel: resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:porkerPanelParent:porkerPanel'
      ),
      targetContainer: resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:porkerPanelParent:porkerPanelCoinTarget'
      ),
      endPosOffsets: { x: 0, y: 0 },
      moveTween: null,
      scaleTween: null,
    },
    jpMajor: {
      coin: resourceManager.get('mainReelsContainer:blueRespin:purpleCoin'),
      panel: resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:majorPanelParent:majorPanel'
      ),
      targetContainer: resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:majorPanelParent:majorPanelCoinTarget'
      ),
      endPosOffsets: { x: 0, y: 0 },
      moveTween: null,
      scaleTween: null,
    },
    jpMaxi: {
      coin: resourceManager.get('mainReelsContainer:blueRespin:greenCoin'),
      panel: resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:maxiPanelParent:maxiPanel'
      ),
      targetContainer: resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:maxiPanelParent:maxiPanelCoinTarget'
      ),
      endPosOffsets: { x: 0, y: 0 },
      moveTween: null,
      scaleTween: null,
    },
    jpMinor: {
      coin: resourceManager.get('mainReelsContainer:blueRespin:orangeCoin'),
      panel: resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:minorPanelParent:minorPanel'
      ),
      targetContainer: resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:minorPanelParent:minorPanelCoinTarget'
      ),
      endPosOffsets: { x: 0, y: 0 },
      moveTween: null,
      scaleTween: null,
    },
    jpMini: {
      coin: resourceManager.get('mainReelsContainer:blueRespin:blueCoin'),
      panel: resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:miniPanelParent:miniPanel'
      ),
      targetContainer: resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:miniPanelParent:miniPanelCoinTarget'
      ),
      endPosOffsets: { x: 0, y: 0 },
      moveTween: null,
      scaleTween: null,
    },
  };
  gameController.jackpotAssetsKeys = Object.keys(gameController.jackpotAssets);

  gameController.jackpotAssets.jpMega.coin.gotoAndStop(0);
  gameController.jackpotAssets.jpMega.coin.visible = false;
  gameController.jackpotAssets.jpPorker.coin.gotoAndStop(0);
  gameController.jackpotAssets.jpPorker.coin.visible = false;
  gameController.jackpotAssets.jpMajor.coin.gotoAndStop(0);
  gameController.jackpotAssets.jpMajor.coin.visible = false;
  gameController.jackpotAssets.jpMaxi.coin.gotoAndStop(0);
  gameController.jackpotAssets.jpMaxi.coin.visible = false;
  gameController.jackpotAssets.jpMinor.coin.gotoAndStop(0);
  gameController.jackpotAssets.jpMinor.coin.visible = false;
  gameController.jackpotAssets.jpMini.coin.gotoAndStop(0);
  gameController.jackpotAssets.jpMini.coin.visible = false;

  Reflex.registerEventHandler('orientationChange', gameController.onOrientationChange);
};

gameController.initNewGame = function (becauseOfRecovery = false) {
  if (!becauseOfRecovery) {
    gameController.skipPiggyAnims();
  }

  gameController.stopCyclingWins();
  gameController.muteCyclingWins = false;

  gameController.totalWinnings = 0;
  gameController.storedPayWinsData = undefined;
  gameController.fsWinnings = 0;
  // gameController.montezumaWinnings = 0;
  gameController.inBuyABonus = false;
  gameController.inBuyABonusFirstSpin = true;
  gameController.preFSReelPrize = 0;
  gameController.stateMachine.switchState('GAME_PLAYING');
  gameController.slotMachine.selectReelMode('default');

  if (!becauseOfRecovery) {
    gameController.initNewSpin();
  } else {
    // make sure symbol are correct
    // especially on br license and restore
    gameController.slotMachine.update(0);
  }

  if (autoplayManager.isAutoplayEnabled()) {
    resourceManager
      .getController('inputOverlord')
      .setText('autoplayCancelButton', String(autoplayManager.getRemainingRounds() - 1));
  }

  // gameController.playLogoAnimation();
};

gameController.initNewSpin = function (recoveryBonusBuy = false) {
  gameController.scatterCount = 0;
  gameController.spinHasWin = 0;
  musicManager.onGameStart();

  gameController._receivedResponse = false;

  gameController.canSlamStop = true;
  gameController.slamStopped = false;
  gameController.longSpinReel = 5;
  gameController._pigAnimationsHandledThisSpin = false;
  gameController.waitingForLandAnim = false;
  gameController.cyclingWins = false;
  gameController.lastPayWinsData = undefined;
  gameController.spinComplete = false;
  gameController.anticpationSymbolsAddedThisSpin = false;
  gameController.winDisplayInProgress = false;
  gameController.pendingFeatureAnimations = [];
  gameController.winDisplayData = null;
  gameController.winCapHit = false;
  gameController.meterFullyUpdated = false;

  // Reset win cap flag in jackpot view
  if (gameController.jackpotView) {
    gameController.jackpotView.resetWinCapTriggered();
  }

  if (!gameController.inFreeSpins) {
    gameData.winningsMeter.set(0);
    gameController.totalWinnings = 0;
    gameController.storedPayWinsData = undefined;
  }

  // if (gameController.currentReelSpin !== undefined) soundManager.stop(gameController.currentReelSpin);
  if (!recoveryBonusBuy && !gameController.inFreeSpins && !autoplayManager.isAutoplayEnabled()) {
    // gameController.currentReelSpin = soundManager.play('reelSpinLoop');
  }

  gameController.symbolAnimator.skip();
  gameController.symbolAnimatorLow.skip();
  // gameController.symbolLandAnimator.skip();
  gameController.symbolAdditionalAnimator.skip();

  musicManager.playSpinButtonSound();
  if (!recoveryBonusBuy) {
    if (gameController.dynamicSpinner) {
      spinController.startSpin();
    } else {
      gameController.slotMachine.infiniteSpin();
    }

    gameController.slotMachine.dimAllSymbols(false, 0.1);
    gameController.symbolOverlayDisplay.dimAllSymbols(false, 0.1);
  }

  gameController.setState_WaitingForServer();
  gameController.featurePrize = 0;
  gameController.reelsPrize = 0;

  gameController.symbolOverlayDisplay.hideAllBonusOverlays();
};

gameController.getCurrentModeStake = function (ignoreGoldenBetMultiplier = false) {
  let stake = 0;

  const stakeController = resourceManager.getController('stakeController');

  if (stakeController) {
    if (gameData.encoreEnabled && !ignoreGoldenBetMultiplier) {
      stake = stakeController.getBaseStake() * 1.5;
    } else {
      stake = stakeController.getBaseStake();
    }

    if (gameController.inBuyABonus) {
      if (gameController.buyBonusLow) {
        stake = stakeController.getCurrentStake('BONUS_BUY_LOW');
      }
      if (gameController.buyBonusMystery) {
        stake = stakeController.getCurrentStake('BONUS_BUY_MYSTERY');
      }
      if (gameController.buyBonusHigh) {
        stake = stakeController.getCurrentStake('BONUS_BUY_HIGH');
      }
    }
  }
  return stake;
};

gameController.getPersistentValues = function (stake, ignoreGoldenBetMultiplier = false) {
  let mode = gameController.getCurrentMode();
  if (mode === 'GOLDENBET_BUY' && !ignoreGoldenBetMultiplier) {
    // stake = stake / 1.5;
  } /*  else {
    mode = 'BASIC';
  } */
  let freeSpinsNum;
  let eliminationLevel;
  let redPigLevel;
  let greenPigLevel;
  let bluePigLevel;
  let goldPigLevel;
  let megaJackpotLevel;
  let porkerJackpotLevel;
  let majorJackpotLevel;
  let maxiJackpotLevel;
  let minorJackpotLevel;
  let miniJackpotLevel;
  let totalUpgrades;
  let awardedPigs;

  if (Object.keys(gameController.persistentValues[mode]).includes('Stake_' + stake, 0) === false) {
    // then select the lowest available stake - used for org=minBet
    freeSpinsNum = Object.values(gameController.persistentValues[mode])[0].freeSpinsNum;
    eliminationLevel = Object.values(gameController.persistentValues[mode])[0].eliminationLevel;
    redPigLevel = Object.values(gameController.persistentValues[mode])[0].redPigLevel;
    greenPigLevel = Object.values(gameController.persistentValues[mode])[0].greenPigLevel;
    bluePigLevel = Object.values(gameController.persistentValues[mode])[0].bluePigLevel;
    goldPigLevel = Object.values(gameController.persistentValues[mode])[0].goldPigLevel;
    megaJackpotLevel = Object.values(gameController.persistentValues[mode])[0].megaJackpot;
    porkerJackpotLevel = Object.values(gameController.persistentValues[mode])[0].porkerJackpot;
    majorJackpotLevel = Object.values(gameController.persistentValues[mode])[0].majorJackpot;
    maxiJackpotLevel = Object.values(gameController.persistentValues[mode])[0].maxiJackpot;
    minorJackpotLevel = Object.values(gameController.persistentValues[mode])[0].minorJackpot;
    miniJackpotLevel = Object.values(gameController.persistentValues[mode])[0].miniJackpot;
    totalUpgrades = Object.values(gameController.persistentValues[mode])[0].totalUpgrades;
    awardedPigs = Object.values(gameController.persistentValues[mode])[0].awardedPigs;
  } else {
    freeSpinsNum = gameController.persistentValues[mode]['Stake_' + stake].freeSpinsNum;
    eliminationLevel = gameController.persistentValues[mode]['Stake_' + stake].eliminationLevel;
    redPigLevel = gameController.persistentValues[mode]['Stake_' + stake].redPigLevel;
    greenPigLevel = gameController.persistentValues[mode]['Stake_' + stake].greenPigLevel;
    bluePigLevel = gameController.persistentValues[mode]['Stake_' + stake].bluePigLevel;
    goldPigLevel = gameController.persistentValues[mode]['Stake_' + stake].goldPigLevel;
    megaJackpotLevel = gameController.persistentValues[mode]['Stake_' + stake].megaJackpot;
    porkerJackpotLevel = gameController.persistentValues[mode]['Stake_' + stake].porkerJackpot;
    majorJackpotLevel = gameController.persistentValues[mode]['Stake_' + stake].majorJackpot;
    maxiJackpotLevel = gameController.persistentValues[mode]['Stake_' + stake].maxiJackpot;
    minorJackpotLevel = gameController.persistentValues[mode]['Stake_' + stake].minorJackpot;
    miniJackpotLevel = gameController.persistentValues[mode]['Stake_' + stake].miniJackpot;
    totalUpgrades = gameController.persistentValues[mode]['Stake_' + stake].totalUpgrades;
    awardedPigs = gameController.persistentValues[mode]['Stake_' + stake].awardedPigs;
  }

  let persistentValues = {
    freeSpinsNum: freeSpinsNum,
    eliminationLevel: eliminationLevel,
    redPigLevel: redPigLevel,
    greenPigLevel: greenPigLevel,
    bluePigLevel: bluePigLevel,
    goldPigLevel: goldPigLevel,
    totalUpgrades: totalUpgrades,
    awardedPigs: awardedPigs,
    miniJackpotLevel: miniJackpotLevel,
    minorJackpotLevel: minorJackpotLevel,
    maxiJackpotLevel: maxiJackpotLevel,
    majorJackpotLevel: majorJackpotLevel,
    porkerJackpotLevel: porkerJackpotLevel,
    megaJackpotLevel: megaJackpotLevel,
    stake: stake,
  };

  return persistentValues;
};

/**
 * Get current persistent state data for the specified stake and mode
 * Returns data structure consistent with restore pattern
 *
 * Used to package data for updateCounters(data)
 */
gameController.getCurrentPersistentStateData = function (stake, mode) {
  if (!stake) {
    let stakeController = resourceManager.getController('stakeController');
    stake = stakeController.getCurrentStake();
  }
  if (!mode) {
    mode = gameController.getCurrentMode();
  }

  // Get persistent values for this stake and mode
  const persistentValues = gameController.getPersistentValues(stake);
  return persistentValues;
};

gameController.updateRedPig = async function (data, instant = false) {
  // so
  // the anims are to look a bit different now
  // they are to shrink back to normal size, then back up to same or bigger
  // and there is to be a little animation if the number increases on the counter

  const redPigLevel = data ? data.redPigLevel : gameController.redPigLevel;
  if (pigSpineController.pigs.redLevel !== redPigLevel) {
    gameController.piggiesChanged = true;
  }
  await gameController.handlePigAnimations(
    {
      red: redPigLevel,
    },
    instant || gameController.skipCurrentPiggieAnims
  );

  const fsIndicator = resourceManager.get('mainReelsContainer:redRespin:freeSpinsText');
  const freeSpinsNum = data ? data.freeSpinsNum : gameController.freeSpinsNum;

  if (fsIndicator.text != freeSpinsNum) {
    gameController.piggiesChanged = true;
    fsIndicator.setText(freeSpinsNum);
    if (!instant) {
      gameController.redRespinParticle.particleEmitter.emit = true;
    }

    if (!instant && !gameController.skipCurrentPiggieAnims) {
      soundManager.play('increaseFreeSpins');
      game.tweenFromToAsync(
        fsIndicator.scale,
        {
          x: fsIndicator.scale.x,
          y: fsIndicator.scale.y,
        },
        {
          x: fsIndicator.scale.x * 1.2,
          y: fsIndicator.scale.y * 1.2,
          duration: 0.25,
          repeat: 1,
          yoyo: true,
        }
      );
      pigSpineController.playIncrementAnimation('red');
    }
  }
};

gameController.updateGreenPig = async function (data, instant = false) {
  const greenPigLevel = data ? data.greenPigLevel : gameController.greenPigLevel;

  if (pigSpineController.pigs.greenLevel !== greenPigLevel) {
    gameController.piggiesChanged = true;
  }

  await gameController.handlePigAnimations(
    {
      green: greenPigLevel,
    },
    instant || gameController.skipCurrentPiggieAnims
  );

  // set the elimination level graphic under the green pig
  const eliminationLevel = data ? data.eliminationLevel : gameController.eliminationLevel;
  if (gameController.standardFreeSpinsController._visualEliminationLevel !== eliminationLevel) {
    gameController.piggiesChanged = true;
    gameController.standardFreeSpinsController.updateEliminationGraphicLevel(eliminationLevel);
    if (!instant) {
      gameController.greenSpinParticles[eliminationLevel].particleEmitter.emit = true;
    }
    if (!instant && !gameController.skipCurrentPiggieAnims) {
      soundManager.play('eliminateSymbol');
      pigSpineController.playIncrementAnimation('green');
    }
  }
};

gameController.whichJackpotsNeedsUpdating = function (jackpots) {
  let updateRequired = false;
  const data = {};
  if (jackpots.jpMega !== gameController.megaJackpotLevel) {
    console.log('doWeNeedToUpdateJackpots Mega has changed');
    data.jpMega = {
      new: jackpots.jpMega,
      old: gameController.megaJackpotLevel,
    };
    updateRequired = true;
  }
  if (jackpots.jpPorker !== gameController.porkerJackpotLevel) {
    console.log('doWeNeedToUpdateJackpots Porker has changed');
    data.jpPorker = {
      new: jackpots.jpPorker,
      old: gameController.porkerJackpotLevel,
    };
    updateRequired = true;
  }
  if (jackpots.jpMajor !== gameController.majorJackpotLevel) {
    console.log('doWeNeedToUpdateJackpots Major has changed');
    data.jpMajor = {
      new: jackpots.jpMajor,
      old: gameController.majorJackpotLevel,
    };
    updateRequired = true;
  }
  if (jackpots.jpMaxi !== gameController.maxiJackpotLevel) {
    console.log('doWeNeedToUpdateJackpots Maxi has changed');
    data.jpMaxi = {
      new: jackpots.jpMaxi,
      old: gameController.maxiJackpotLevel,
    };
    updateRequired = true;
  }
  if (jackpots.jpMinor !== gameController.minorJackpotLevel) {
    console.log('doWeNeedToUpdateJackpots Minor has changed');
    data.jpMinor = {
      new: jackpots.jpMinor,
      old: gameController.minorJackpotLevel,
    };
    updateRequired = true;
  }
  if (jackpots.jpMini !== gameController.miniJackpotLevel) {
    console.log('doWeNeedToUpdateJackpots Mini has changed');
    data.jpMini = {
      new: jackpots.jpMini,
      old: gameController.miniJackpotLevel,
    };
    updateRequired = true;
  }

  if (updateRequired) {
    return data;
  }

  return null;
};

gameController.updateBluePig = async function (data, instant = false) {
  const bluePigLevel = data ? data.bluePigLevel : gameController.bluePigLevel;

  if (pigSpineController.pigs.blueLevel !== bluePigLevel) {
    gameController.piggiesChanged = true;
  }

  console.log('gameController.updateBluePig');

  await gameController.handlePigAnimations(
    {
      blue: bluePigLevel,
    },
    instant || gameController.skipCurrentPiggieAnims
  );

  console.log('gameController.updateBluePig - handlePigAnimations done');

  // there is supposed to be a whole other animation, where a coin comes from the pig
  // to the relevant pot
  // how do we know if the jackpots have been updated?
  const updateRequired = gameController.whichJackpotsNeedsUpdating(
    gameController.spinTask.data.pendingDisplayStateUpdate.postBase.afterPart.jackpotPots
  );

  if (updateRequired !== null) {
    gameController.piggiesChanged = true;
    if (!instant && !gameController.skipCurrentPiggieAnims) {
      pigSpineController.playIncrementAnimation('blue');
    }
    console.log('jackpots changed', updateRequired);
    // ok who handles this animation?
    // but we should now know which pots need updating
    await gameController.updateJackpotValuesAfterBlueCoin(updateRequired, instant);
    console.log('gameController.updateBluePig - updateJackpotValuesAfterBlueCoin done');
  }
};

gameController.updateJackpotValuesAfterBlueCoin = async function (jackpotsToUpdate, instant = false) {
  // so we need to go through the object, sending out a coin to the relevant pot and update the value
  // and play particle when it gets there
  // if we can get all coins moving at once with a bit of a delay between each coin
  const promises = [];

  let delay = 0;

  gameController.movingCoinsToJackpotAndUpdatingValues = true;

  const keys = Object.keys(jackpotsToUpdate);
  for (let i = 0; i < keys.length; i++) {
    // await timerManager.delayAsync(delay);
    promises.push(
      gameController.moveCoinToJackpotAndUpdate(
        keys[i],
        jackpotsToUpdate[keys[i]].old,
        jackpotsToUpdate[keys[i]].new,
        delay,
        instant
      )
    );
    if (!instant && !gameController.skipCurrentPiggieAnims) {
      delay += 300;
    } else {
      delay = 0;
    }
  }

  await Promise.all(promises);

  gameController.movingCoinsToJackpotAndUpdatingValues = false;
};

gameController.moveCoinToJackpotAndUpdate = async function (
  jackpotName,
  fromValue,
  toValue,
  delayInMS = 0,
  instant = false
) {
  // we will only ever get 1 coin per jackpot, so if we name the tweens using the jackpot Name
  // we need to remember about being able to cancel the move tween
  const assets = gameController.jackpotAssets[jackpotName];
  const coin = assets.coin;
  const panel = assets.panel;
  const targetContainer = assets.targetContainer;

  // store current data - so we can restore after the anim
  coin.origParent = coin.parent; // so we can put it back
  coin.origScale = coin.scale.x; //
  coin.origX = coin.x;
  coin.origY = coin.y;
  // we have to reparent the coin
  // otherwise it will appear under the panel
  // convert coins current coords so it appears in same place once parent changed
  const stage = systemData.stage;
  const newParent = resourceManager.get('mainReelsContainer:potDisplay:potDisplayContainer');
  const startXY = newParent.toLocal(coin.toGlobal(stage));
  coin.x = startXY.x;
  coin.y = startXY.y;
  newParent.addChild(coin);

  // we also need to convert the panels coords
  const endXY = newParent.toLocal(targetContainer.toGlobal(stage));

  const startPoint = { x: coin.x, y: coin.y };
  const endPoint = { x: endXY.x + assets.endPosOffsets.x, y: endXY.y - coin.height / 2 };

  const parabolicPath = gameController.calculateParabolicPath(startPoint, endPoint);

  // Use GSAP to animate coin along parabolic path with scale
  // coin.visible = true;
  // coin.gotoAndPlay(0);

  let scaleResolver = null;
  const scalePromise = new Promise((resolve) => {
    scaleResolver = resolve;
  });

  const duration = instant || gameController.skipCurrentPiggieAnims ? 0 : 0.8;
  const delay = instant || gameController.skipCurrentPiggieAnims ? 0 : delayInMS;

  assets.scaleTween = gsap.fromTo(
    coin.scale,
    {
      x: coin.scale.x,
      x: coin.scale.y,
    },
    {
      delay: delay / 1000,
      duration: duration / 2,
      x: 0.6,
      y: 0.6,
      repeat: 1,
      yoyo: true,
      ease: 'power2.out',
      yoyoEase: 'power2.in',
      onStart: () => {
        coin.visible = true;
        coin.gotoAndPlay(0);
      },
      onComplete: () => {
        scaleResolver();
      },
    }
  );

  const soundToPlay = {
    jpMega: 'coinLandAtMega',
    jpPorker: 'coinLandAtPorker',
    jpMajor: 'coinLandAtMajor',
    jpMaxi: 'coinLandAtMaxi',
    jpMinor: 'coinLandAtMinor',
    jpMini: 'coinLandAtMini',
  };

  let moveResolver = null;
  const movePromise = new Promise((resolve) => {
    moveResolver = resolve;
  });

  let whooshSoundID = undefined;
  // Animate position along parabolic path
  assets.moveTween = gsap.fromTo(
    coin,
    {
      x: coin.x,
      y: coin.y,
    },
    {
      delay: delay / 1000,
      duration: duration,
      motionPath: {
        path: parabolicPath,
        autoRotate: false,
        alignOrigin: [0.5, 0.5],
      },
      ease: 'power2.out',
      onStart: () => {
        if (!instant && !gameController.skipCurrentPiggieAnims) {
          whooshSoundID = soundManager.play('coinWhoosh');
        }
      },
      onComplete: () => {
        moveResolver();
        if (!instant) {
          soundManager.stop(whooshSoundID);
          const sound = soundToPlay[jackpotName];
          soundManager.play(sound);
        }
      },
    }
  );

  await Promise.all([scalePromise, movePromise]);

  coin.gotoAndStop(0);

  coin.visible = false;
  coin.origParent.addChild(coin);
  coin.x = coin.origX;
  coin.y = coin.origY;
  coin.scale.set(coin.origScale);

  const indexMap = {
    jpMega: 20,
    jpPorker: 19,
    jpMajor: 18,
    jpMaxi: 17,
    jpMinor: 16,
    jpMini: 15,
  };

  if (!instant) {
    gameController.jackpotView.playParticleEffect(indexMap[jackpotName]);
  }

  const nameMap = {
    jpMega: 'Mega',
    jpPorker: 'Porker',
    jpMajor: 'Major',
    jpMaxi: 'Maxi',
    jpMinor: 'Minor',
    jpMini: 'Mini',
  };

  const jackpotDisplay = resourceManager.get('mainReelsContainer:potDisplay');
  await jackpotDisplay.countUpPotFromTo(
    nameMap[jackpotName],
    fromValue,
    toValue,
    instant || gameController.skipCurrentPiggieAnims
  );

  switch (jackpotName) {
    case 'jpMega':
      gameController.megaJackpotLevel = toValue;
      break;
    case 'jpPorker':
      gameController.porkerJackpotLevel = toValue;
      break;
    case 'jpMajor':
      gameController.majorJackpotLevel = toValue;
      break;
    case 'jpMaxi':
      gameController.maxiJackpotLevel = toValue;
      break;
    case 'jpMinor':
      gameController.minorJackpotLevel = toValue;
      break;
    case 'jpMini':
      gameController.miniJackpotLevel = toValue;
      break;
  }
};

gameController.updateGoldPig = async function (data, instant = false) {
  const goldPigLevel = data ? data.goldPigLevel : gameController.goldPigLevel;

  if (pigSpineController.pigs.goldLevel !== goldPigLevel) {
    gameController.piggiesChanged = true;
  }

  await gameController.handlePigAnimations(
    {
      gold: goldPigLevel,
    },
    instant || gameController.skipCurrentPiggieAnims
  );

  const awardedPigs = data ? data.awardedPigs : gameController.awardedPigs;
  let goldIndicator = resourceManager.get('mainReelsContainer:goldRespin:goldPigText');
  // if the text is going to increment, we need to change text and play another anim
  if (goldIndicator.text != awardedPigs) {
    gameController.piggiesChanged = true;
    goldIndicator.setText(awardedPigs);
    if (!instant) {
      gameController.goldRespinParticle.particleEmitter.emit = true;
    }
    if (!instant && !gameController.skipCurrentPiggieAnims) {
      soundManager.play('increaseFreeSpins');
      game.tweenFromToAsync(
        goldIndicator.scale,
        {
          x: goldIndicator.scale.x,
          y: goldIndicator.scale.y,
        },
        {
          x: goldIndicator.scale.x * 1.2,
          y: goldIndicator.scale.y * 1.2,
          duration: 0.25,
          repeat: 1,
          yoyo: true,
        }
      );
      pigSpineController.playIncrementAnimation('gold');
    }
  }
};

/**
 * Update persistent values here
 */
gameController.updateCounters = function (data, fromForce = false, fromStakeChange = false) {
  // there is a point where these counters arent to be updated
  // e.g. when entering a feature we dont want red counter to
  // go from 11 to 9
  // that needs to happen at the end of the feature

  // Use provided data parameter if available, otherwise fall back to gameController properties
  const eliminationLevel = data ? data.eliminationLevel : gameController.eliminationLevel;
  const freeSpinsNum = data ? data.freeSpinsNum : gameController.freeSpinsNum;
  const redPigLevel = data ? data.redPigLevel : gameController.redPigLevel;
  const bluePigLevel = data ? data.bluePigLevel : gameController.bluePigLevel;
  const greenPigLevel = data ? data.greenPigLevel : gameController.greenPigLevel;
  const goldPigLevel = data ? data.goldPigLevel : gameController.goldPigLevel;
  const megaJackpot = data ? data.megaJackpotLevel : gameController.megaJackpotLevel;
  const porkerJackpot = data ? data.porkerJackpotLevel : gameController.porkerJackpotLevel;
  const majorJackpot = data ? data.majorJackpotLevel : gameController.majorJackpotLevel;
  const maxiJackpot = data ? data.maxiJackpotLevel : gameController.maxiJackpotLevel;
  const minorJackpot = data ? data.minorJackpotLevel : gameController.minorJackpotLevel;
  const miniJackpot = data ? data.miniJackpotLevel : gameController.miniJackpotLevel;
  const totalUpgrades = data ? data.totalUpgrades : gameController.totalUpgrades;
  const awardedPigs = data ? data.awardedPigs : gameController.awardedPigs;

  if (fromForce === true) {
    console.log('updating piggies because of force');
    console.log(`green level ${greenPigLevel} elimination ${eliminationLevel}`);
    console.log(`red level ${redPigLevel} spins ${freeSpinsNum}`);
    console.log(`gold level ${goldPigLevel} awarded ${awardedPigs}`);
    console.log(`blue level ${bluePigLevel}`);
  }

  // set the elimination level graphic under the green pig
  gameController.standardFreeSpinsController.updateEliminationGraphicLevel(eliminationLevel);

  // update any changes to the jackpot levels
  let jackpotDisplay = resourceManager.get('mainReelsContainer:potDisplay');
  jackpotDisplay.updatePotValues();

  // update red freespins number
  let fsIndicator = resourceManager.get('mainReelsContainer:redRespin:freeSpinsText');
  fsIndicator.setText(freeSpinsNum);

  // update gold pig wheel indicator
  let goldIndicator = resourceManager.get('mainReelsContainer:goldRespin:goldPigText');
  goldIndicator.setText(awardedPigs);

  // update pig sizes
  gameController.handlePigAnimations(
    {
      red: redPigLevel,
      green: greenPigLevel,
      gold: goldPigLevel,
      blue: bluePigLevel,
    },
    true,
    fromStakeChange
  );
};

gameController.updateCountersAfterFreeSpins = function (data) {
  // Use provided data parameter if available, otherwise fall back to gameController properties
  const eliminationLevel = data ? data.eliminationLevel : gameController.eliminationLevel;
  const freeSpinsNum = data ? data.freeSpinsNum : gameController.freeSpinsNum;
  const redPigLevel = data ? data.redPigLevel : gameController.redPigLevel;
  const bluePigLevel = data ? data.bluePigLevel : gameController.bluePigLevel;
  const greenPigLevel = data ? data.greenPigLevel : gameController.greenPigLevel;
  const goldPigLevel = data ? data.goldPigLevel : gameController.goldPigLevel;
  const awardedPigs = data ? data.awardedPigs : gameController.awardedPigs;

  // set the elimination level graphic under the green pig
  gameController.standardFreeSpinsController.updateEliminationGraphicLevel(eliminationLevel);

  // update any changes to the jackpot levels
  let jackpotDisplay = resourceManager.get('mainReelsContainer:potDisplay');
  jackpotDisplay.updatePotValues();

  // update red freespins number
  let fsIndicator = resourceManager.get('mainReelsContainer:redRespin:freeSpinsText');
  fsIndicator.setText(freeSpinsNum);

  // update gold pig wheel indicator
  let goldIndicator = resourceManager.get('mainReelsContainer:goldRespin:goldPigText');
  goldIndicator.setText(awardedPigs);

  // resize active pigs back to where there are supposed to be
  // resize deactivated pigs back

  // update pig sizes
  gameController.resetPigsAfterFreeSpins(
    {
      red: redPigLevel,
      green: greenPigLevel,
      gold: goldPigLevel,
      blue: bluePigLevel,
    },
    false
  );
};

gameController.updateCounterState = function (stake) {
  if (!gameData.slotConfig.inReplayMode) {
    gameController.currentPersistentState = gameController.getPersistentValues(stake);
    gameController.freeSpinsNum = gameController.currentPersistentState.freeSpinsNum;
    gameController.eliminationLevel = gameController.currentPersistentState.eliminationLevel;
    gameController.redPigLevel = gameController.currentPersistentState.redPigLevel;
    gameController.greenPigLevel = gameController.currentPersistentState.greenPigLevel;
    gameController.bluePigLevel = gameController.currentPersistentState.bluePigLevel;
    gameController.goldPigLevel = gameController.currentPersistentState.goldPigLevel;
    gameController.megaJackpotLevel = gameController.currentPersistentState.megaJackpotLevel;
    gameController.porkerJackpotLevel = gameController.currentPersistentState.porkerJackpotLevel;
    gameController.majorJackpotLevel = gameController.currentPersistentState.majorJackpotLevel;
    gameController.maxiJackpotLevel = gameController.currentPersistentState.maxiJackpotLevel;
    gameController.minorJackpotLevel = gameController.currentPersistentState.minorJackpotLevel;
    gameController.miniJackpotLevel = gameController.currentPersistentState.miniJackpotLevel;
    gameController.totalUpgrades = gameController.currentPersistentState.totalUpgrades;
    gameController.awardedPigs = gameController.currentPersistentState.awardedPigs;
  } else {
    gameController.currentPersistentState = gameController.getPersistentValues(stake);
    gameController.freeSpinsNum = gameController.currentPersistentState.freeSpinsNum;
    gameController.eliminationLevel = gameController.currentPersistentState.eliminationLevel;
    gameController.redPigLevel = gameController.currentPersistentState.redPigLevel;
    gameController.greenPigLevel = gameController.currentPersistentState.greenPigLevel;
    gameController.bluePigLevel = gameController.currentPersistentState.bluePigLevel;
    gameController.goldPigLevel = gameController.currentPersistentState.goldPigLevel;
    gameController.megaJackpotLevel = gameController.currentPersistentState.megaJackpotLevel;
    gameController.porkerJackpotLevel = gameController.currentPersistentState.porkerJackpotLevel;
    gameController.majorJackpotLevel = gameController.currentPersistentState.majorJackpotLevel;
    gameController.maxiJackpotLevel = gameController.currentPersistentState.maxiJackpotLevel;
    gameController.minorJackpotLevel = gameController.currentPersistentState.minorJackpotLevel;
    gameController.miniJackpotLevel = gameController.currentPersistentState.miniJackpotLevel;
    gameController.totalUpgrades = gameController.currentPersistentState.totalUpgrades;
    gameController.awardedPigs = gameController.currentPersistentState.awardedPigs;
  }
};

gameController.numCoinsGoingToLand = function (shutterData) {
  const symbolCfg = resourceManager.getConfiguration().symbols;

  const redCoinId = symbolCfg['RedCoin'].ID;
  const goldCoinId = symbolCfg['GoldCoin'].ID;
  const greenCoinId = symbolCfg['GreenCoin'].ID;
  const blueCoinId = symbolCfg['BlueCoin'].ID;

  let numCoins = 0;
  let redCoins = 0;
  let goldCoins = 0;
  let greenCoins = 0;
  let blueCoins = 0;

  for (let i = 0; i < shutterData.length; i++) {
    for (let k = 0; k < shutterData[i].revealedSymbols.length; k++) {
      switch (shutterData[i].revealedSymbols[k]) {
        case redCoinId:
          numCoins++;
          redCoins++;
          break;
        case goldCoinId:
          numCoins++;
          goldCoins++;
          break;
        case greenCoinId:
          numCoins++;
          greenCoins++;
          break;
        case blueCoinId:
          numCoins++;
          blueCoins++;
          break;
      }
    }
  }

  return {
    numCoins: numCoins,
    redCoins: redCoins,
    goldCoins: goldCoins,
    greenCoins: greenCoins,
    blueCoins: blueCoins,
  };
};

gameController.isCoinFrenzyAnimRequired = function (shutterData, pendingDisplayStateUpdate) {
  let result = false;
  let numCoins = gameController.numCoinsGoingToLand(shutterData);

  // In the base game, where a level increment or a bonus trigger occurs and more than TBC coins will land in view
  const minCoinsRequired = 3;
  if (
    numCoins.numCoins >= minCoinsRequired &&
    pendingDisplayStateUpdate &&
    pendingDisplayStateUpdate.postBase &&
    pendingDisplayStateUpdate.postBase.changes
  ) {
    // now we could have a scenario where a coin does nothing - yeah bonkers right
    // so we need to make sure a coin is going to increase the level of a pig
    // we also may have a scenario where you are forcing something, and multiple pigs change, but we only get 1 coloured coin
    if (numCoins.redCoins > 0 && typeof pendingDisplayStateUpdate.postBase.changes.red === 'object') {
      result = true;
    } else if (numCoins.goldCoins > 0 && typeof pendingDisplayStateUpdate.postBase.changes.gold === 'object') {
      result = true;
    } else if (numCoins.greenCoins > 0 && typeof pendingDisplayStateUpdate.postBase.changes.green === 'object') {
      result = true;
    } else if (numCoins.blueCoins > 0 && typeof pendingDisplayStateUpdate.postBase.changes.blue === 'object') {
      result = true;
    }
  }

  return result;
};

gameController.doSpin = function (spinTask) {
  // ---------------------SET INITAL DATA ON SPIN---------------------\\
  // THIS IS NECESSARY FOR WHEN FORCING, AS THE INITIAL STATE WILL BE DIFFERENT WHEN FORCING (CHECK IF FORCING AND ONLY DO THIS IF IT IS?)
  // const initialDisplayState = spinTask.data.initialDisplayState;
  // pigSpineController.initializeSizes(initialDisplayState);
  // ----------------------------------------------------\\

  // if (gameController.inFreeSpins) {
  //   gameController.fetaureType = spinTask.data.featureSpinsPart.featureType;
  // }

  // Clear any running spine animations from previous wins
  spineSymbolAnimator.skip();

  gameData.spinData = spinTask.data;
  gameController.spinHasWin = spinTask.data.winAmountPresent;
  gameController.spinTask = spinTask;
  gameController.spinTask.join();

  if (!gameController.inFreeSpins) {
    gameController.bonusTriggeringReels = [];
  }

  gameController.isPrePaid = spinTask.data.isPrePaidGame;
  gameController.shutterData = spinTask.data.shutterData || [];
  // Set shutter animation state immediately when we know if shutters exist
  gameController.shutterAnimationsComplete = gameController.shutterData.length === 0;

  // Store pending display state update to process after shutter animations
  if (!gameController.inFreeSpins) {
    gameController.pendingDisplayStateUpdate = spinTask.data.pendingDisplayStateUpdate || null;
  }

  // before we stop the reels
  // so we have the coin frenzy animation to play?
  const doCoinFrenzy = gameController.isCoinFrenzyAnimRequired(
    gameController.shutterData,
    gameController.pendingDisplayStateUpdate
  );
  // how many coins to we need to display the coin frenzy animation?
  if (!doCoinFrenzy) {
    gameController.stateMachine.switchState('SPIN_REELS_SPINNING');
  } else {
    gameController._coinFrenzyDelaySlamStop = true;
    gameController.stateMachine.switchState('COIN_FRENZY');
  }
  gameController._receivedResponse = true;

  gameData.reelsSpinning = 5;

  gameController.finalFreeSpin = spinTask.data.finalFreeSpin;

  if (gameController.inBuyABonus && gameController.inBuyABonusFirstSpin) {
    gameController.inBuyABonusFirstSpin = false;
  }

  if (spinTask.data.localRng) {
    gameController.rng.seed(spinTask.data.localRng);
  }

  // Setup spin related bonuses
  gameController.freeSpinsData = spinTask.data.freeSpinsData;

  // before we stop the reels
  // so we have the coin frenzy animation to play?
  if (!doCoinFrenzy) {
    // Set up data for the reels
    const symbols = [];
    const above = [];
    const below = [];
    for (let reel = 0; reel < spinTask.data.resultPanel.reelList.length; reel++) {
      symbols.push([]);
      above.push([]);
      below.push([]);
      for (let row = 0; row < spinTask.data.resultPanel.reelList[reel].symbols.length; row++) {
        symbols[reel].push(spinTask.data.resultPanel.reelList[reel].symbols[row].value);
      }
    }
    if (gameController.dynamicSpinner) {
      spinController.stopSpin(symbols, above, below, gameController.onSpinComplete);
    } else {
      gameController.slotMachine.stopReels(symbols, above, below, gameController.onSpinComplete);
    }
  }
};

gameController.playLandSounds = function (reel) {
  soundManager.play(`reelStop${reel}`);
};

gameController.start = function () {
  gameController.stateMachine.switchState('WAITING_FOR_START');
};

gameController.onSpinComplete = function () {
  //if (gameController.inFreeSpins) {
  //  gameController.symbolOverlayDisplay.hideWildPanels();
  //}
  gameController.tempIgnoreUpdateCountersBecauseOfRestore = false;
  gameController.skipCurrentPiggieAnims = false;
  gameController.spinComplete = true;
  gameController._receivedResponse = true;
  gameController.slamStopped = false;
  soundManager.stop('reelSpinLoop');

  // Trigger present opening animations if we have shutter data
  if (
    gameController.shutterData.length > 0 ||
    (gameController.inFreeSpins && gameController.freeSpinsShutterData[gameController.freeSpinsNum - 1].length > 0)
  ) {
    gameController.shutterAnimationsComplete = false;

    // when slam stopping the symbols haven't been placed in their final position yet, so call startPresentAnimations
    // on next tick so that it can grab symbol final positions.
    timerManager.addTimeout(100, () => {
      gameController.startPresentAnimations();
    });
  } else {
    // No shutters, so animations are considered complete
    gameController.shutterAnimationsComplete = true;
    // gameController.handleSoundLevel(true);
  }

  gameController.stateMachine.switchState('WAITING_FOR_REELS');
  // const spinButton = resourceManager.get('buttonContainer:buttonBar:spinButton');
};

gameController.getIsRecovery = function () {
  return gameController.inRecovery;
};

gameController.startPresentAnimations = async function () {
  let spinIndex = 0;
  let shutterInfo = undefined;

  // Check if we're in free spins first to determine which data to use
  if (gameController.inFreeSpins) {
    spinIndex = gameController.freeSpinsController.getSpinIndex();
    if (gameController.freeSpinsShutterData[spinIndex].length > 0) {
      shutterInfo = gameController.freeSpinsShutterData[spinIndex];

      // Sort free spins shutters by position (reel first, then row)
      shutterInfo.sort((a, b) => {
        if (a.pos.reel !== b.pos.reel) return a.pos.reel - b.pos.reel;
        return a.pos.row - b.pos.row;
      });
    }
  } else if (gameController.shutterData.length > 0) {
    shutterInfo = gameController.shutterData;

    // Sort base game shutters by position (reel first, then row)
    shutterInfo.sort((a, b) => {
      if (a.reel !== b.reel) return a.reel - b.reel;
      return a.row - b.row;
    });
  }

  // Process shutters if we have any
  if (shutterInfo && shutterInfo.length > 0) {
    // Start all present animations simultaneously using Promise.all
    const presentAnimationPromises = [];

    if (shutterInfo.length > 0) {
      if (shutterInfo.length >= 10) {
        soundManager.play('presentOpenLots');
      } else {
        soundManager.play('presentOpen');
      }
    }
    // Build present animation promises based on game mode
    if (gameController.inFreeSpins) {
      // Free spins use different data structure
      for (let i = 0; i < shutterInfo.length; i++) {
        let shutter = shutterInfo[i];
        presentAnimationPromises.push(
          gameController.playPresentAnimation(
            shutter.pos.reel,
            shutter.pos.row,
            shutter.originalSymbol,
            shutter.symbols,
            i
          )
        );
      }
    } else {
      // Base game structure
      for (let i = 0; i < shutterInfo.length; i++) {
        let shutter = shutterInfo[i];
        presentAnimationPromises.push(
          gameController.playPresentAnimation(
            shutter.reel,
            shutter.row,
            shutter.originalSymbol,
            shutter.revealedSymbols,
            i
          )
        );
      }
    }

    // Wait for all present animations to complete, then process coins sequentially
    const shutterResults = await Promise.all(presentAnimationPromises);

    // can we sort shutterResults to make sure the blue coin is processed 1st?
    // how about we look for the blue coin and bring it to the front of the array
    // we will only ever have a max of 1 blue coin
    if (!gameController.inFreeSpins) {
      let blueCoinFoundAt = -1;
      const blueCoinID = resourceManager.getConfiguration().symbols['BlueCoin'].ID;
      for (let k = 0; k < shutterResults.length && blueCoinFoundAt === -1; k++) {
        for (let j = 0; j < shutterResults[k].coinSymbols.length && blueCoinFoundAt === -1; j++) {
          if (shutterResults[k].coinSymbols[j] === blueCoinID) {
            // we have a blue coin
            blueCoinFoundAt = k;
            if (j !== 0) {
              // lets move stuff around
              const movieTemp = shutterResults[k].coinMovies[0];
              const coinIDTemp = shutterResults[k].coinSymbols[0];
              shutterResults[k].coinMovies[0] = shutterResults[k].coinMovies[j];
              shutterResults[k].coinSymbols[0] = shutterResults[k].coinSymbols[j];
              shutterResults[k].coinMovies[j] = movieTemp;
              shutterResults[k].coinSymbols[j] = coinIDTemp;
            }
          }
        }
      }

      if (blueCoinFoundAt > 0) {
        const temp = shutterResults[0];
        shutterResults[0] = shutterResults[blueCoinFoundAt];
        shutterResults[blueCoinFoundAt] = temp;
      }

      if (gameController.movingCoinsToJackpotAndUpdatingValues) {
        gameController.skipMovingCoinsToJackpotPanels();
      }
      await gameController.waitForAllPigUpdatesToFinish();

      if (shutterResults.length > 0) {
        await timerManager.delayAsync(800);
        gameController.movingCoinsToPigs = false;
        const promises = [];
        let delay = 0;
        gameController.movingCoinsToPigsTweens = [];
        // Now process coins sequentially for each shutter
        for (let i = 0; i < shutterResults.length; i++) {
          const { coinMovies, coinSymbols } = shutterResults[i];

          if (coinMovies.length > 0) {
            // a shutter could have 1 or 2 coins behind it
            promises.push(moveCoinsToPots(coinMovies, coinSymbols, delay));
            delay += 300 * coinMovies.length;
          }
        }

        await Promise.all(promises);
        gameController.movingCoinsToPigs = false;
        gameController.movingCoinsToPigsTweens = [];
      }
    } else {
      // Check if any shutter has coins to process
      const hasCoins = shutterResults.some((result) => result.coinMovies.length > 0);

      // Allow time for players to see all coins spinning in place (only if there are coins)
      if (hasCoins) {
        await timerManager.delayAsync(650);
      }

      // free spins
      // we wait for each coin
      // Now process coins sequentially for each shutter
      for (let i = 0; i < shutterResults.length; i++) {
        const { coinMovies, coinSymbols } = shutterResults[i];

        if (coinMovies.length > 0) {
          await moveCoinsToPots(coinMovies, coinSymbols);
        }
      }
    }
  }

  gameController.waitForAllPigUpdatesToFinish();
  // All shutter processing complete (presents, coins, jackpots) - set completion flag
  gameController.shutterAnimationsComplete = true;
  // gameController.handleSoundLevel(true);
};

// Handle display state updates from server
gameController.onDisplayStateUpdate = async function (displayState) {
  const promises = [];
  Object.entries(displayState).forEach(async ([pigColour, changes]) => {
    // does changes include displayLevelIndex which is a display update
    if (changes.displayLevelIndex !== undefined) {
      promises.push(pigSpineController.playGrowAnimation(pigColour, changes.displayLevelIndex));
      gameController._pigAnimationsHandledThisSpin = true;
    }
  });

  await Promise.all(promises);
};

// Handle pig animations based on display state changes
gameController.handlePigAnimations = async function (pigs, instant = true, fromStakeChange = false) {
  const promises = [];
  Object.entries(pigs).forEach(([pigColour, level]) => {
    // has pig changed size?
    // this doesnt matter anymore
    if (fromStakeChange || instant || gameController.skipCurrentPiggieAnims) {
      promises.push(pigSpineController.resetOnStakeChange(pigColour, level));
    } else {
      promises.push(pigSpineController.playShrinkAndGrowAnimation(pigColour, level, instant));
    }
  });

  await Promise.all(promises);
};

gameController.playPigActivateAnimation = async function (pigNames, playSfx = true) {
  // loop over the pigNames storing all the promises and wait for all to finish
  if (playSfx) {
    soundManager.play('pigTrigger');
    if (pigNames.length === 1 && pigNames[0] === 'gold') {
      soundManager.play('goldPigTriggered_1');
    } else {
      if (pigNames.length === 1) {
        soundManager.play('pigTriggered_1');
      } else if (pigNames.length === 2) {
        soundManager.play('pigsTriggered_2');
      } else {
        soundManager.play('pigsTriggered_3');
      }
    }
  }

  const promises = [];
  for (let i = 0; i < pigNames.length; i++) {
    promises.push(pigSpineController.playActivateAnimation(pigNames[i]));
  }

  await Promise.all(promises);

  // return new Promise((res) => {
  //   // pig names can be a singular pig as well as array
  //   pigSpineController.playWinReact(pigNames, res);
  // });
};

gameController.tintPigStatus = function (pigName, tint = 0x777777) {
  switch (pigName) {
    case 'red':
      const fsPanel = resourceManager.get('mainReelsContainer:redRespin');
      const fsArrow = resourceManager.get('mainReelsContainer:redRespin:redArrow');
      const fsIndicator = resourceManager.get('mainReelsContainer:redRespin:freeSpinsText');
      fsPanel.tint = tint;
      fsArrow.tint = tint;
      fsIndicator.tint = tint;
      break;
    case 'green':
      const greenRespin2 = resourceManager.get('mainReelsContainer:greenRespin2');
      const greenRespin3 = resourceManager.get('mainReelsContainer:greenRespin3');
      const greenRespin4 = resourceManager.get('mainReelsContainer:greenRespin4');
      const greenRespin5 = resourceManager.get('mainReelsContainer:greenRespin5');
      const greenRespin6 = resourceManager.get('mainReelsContainer:greenRespin6');
      const greenRespin7 = resourceManager.get('mainReelsContainer:greenRespin7');
      const greenSpinArrow = resourceManager.get('mainReelsContainer:greenSpinArrow');
      greenRespin2.tint = tint;
      greenRespin3.tint = tint;
      greenRespin4.tint = tint;
      greenRespin5.tint = tint;
      greenRespin6.tint = tint;
      greenRespin7.tint = tint;
      greenSpinArrow.tint = tint;
      break;
    case 'gold':
      const wheelPanel = resourceManager.get('mainReelsContainer:goldRespin');
      const wheelText = resourceManager.get('mainReelsContainer:goldRespin:goldPigText');
      const goldArrow = resourceManager.get('mainReelsContainer:goldRespin:goldArrow');
      const goldTriangle = resourceManager.get('mainReelsContainer:goldRespin:goldTriangle');
      wheelPanel.tint = tint;
      wheelText.tint = tint;
      goldArrow.tint = tint;
      goldTriangle.tint = tint;
      break;
    case 'blue':
      const jpPanel = resourceManager.get('mainReelsContainer:blueRespin');
      const blueArrow = resourceManager.get('mainReelsContainer:blueRespin:blueArrow');
      jpPanel.tint = tint;
      blueArrow.tint = tint;
      break;
  }
};

gameController.playPigDeactivateAnimation = async function (pigNames) {
  // loop over the pigNames storing all the promises and wait for all to finish
  const promises = [];
  for (let i = 0; i < pigNames.length; i++) {
    gameController.tintPigStatus(pigNames[i]);
    promises.push(pigSpineController.playDeactivateAnimation(pigNames[i]));
  }

  await Promise.all(promises);

  // return new Promise((res) => {
  //   // pig names can be a singular pig as well as array
  //   pigSpineController.playWinReact(pigNames, res);
  // });
};

gameController.resetPigsAfterFreeSpins = async function (pigs) {
  const promises = [];
  Object.entries(pigs).forEach(([pigColour, level]) => {
    gameController.tintPigStatus(pigColour, 0xffffff);
    promises.push(pigSpineController.resetAfterFreeSpins(pigColour, level));
  });

  await Promise.all(promises);
};

gameController.createOriginalSymbolSprite = function (reel, row, symbolId, symbolPosition) {
  // Create resource name based on position and symbol type for reusability
  const spriteName = 'OriginalSymbol_' + reel + '_' + row + '_' + symbolId;

  // Check if this resource already exists
  let existingSprite = resourceManager.get('mainReelsContainer:presentAnimationContainer:' + spriteName);
  if (existingSprite) {
    // IMPORTANT: Ensure reused original symbol is hidden initially
    existingSprite.visible = false;
    return existingSprite;
  }

  // Map symbol IDs to their file names
  const symbolFileMap = {
    0: 'Symbols/Ten/PPP_Symbols_10_00000.png',
    1: 'Symbols/Jack/PPP_Symbols_J_00000.png',
    2: 'Symbols/Queen/PPP_Symbols_Q_00000.png',
    3: 'Symbols/King/PPP_Symbols_K_00000.png',
    4: 'Symbols/Ace/PPP_Symbols_A_00000.png',
    5: 'Symbols/Cake/PPP_Symbols_Cake_00000.png',
    6: 'Symbols/Hogtail/PPP_Symbols_Hogtail_00000.png',
    7: 'Symbols/Disco/PPP_Symbols_Disco_00000.png',
    8: 'Symbols/Dancer/PPP_Symbols_Dancer_00000.png',
    9: 'Symbols/Logo/PPP_Symbols_Logo_00000.png',
    10: 'Symbols/Wild/PPP_Symbols_Wild_00000.png',
  };

  const fileName = symbolFileMap[symbolId];
  if (!fileName) {
    return null;
  }

  let newSprite = resourceManager.createObject('sprite', spriteName, 'mainReelsContainer:presentAnimationContainer', {
    fileName: fileName,
    scale: 1.0,
    anchor: 0.5,
    visible: false,
  });

  // Set position only for newly created sprites
  if (newSprite && symbolPosition) {
    newSprite.x = symbolPosition.x;
    newSprite.y = symbolPosition.y;
  }

  return newSprite;
};

// Helper function to calculate parabolic path for coin to pig animation
gameController.calculateParabolicPath = function (start, end) {
  // Calculate distance between start and end points
  const distance = Math.sqrt((end.x - start.x) * (end.x - start.x) + (end.y - start.y) * (end.y - start.y));

  // Calculate arc height based on distance (higher arc for longer distances)
  const arcHeight = Math.min(distance * 0.25, 50); // Max 50px height

  // Calculate peak point
  const peak = {
    x: start.x + (end.x - start.x) * 0.6,
    y: Math.min(start.y, end.y) - arcHeight,
  };

  // Adjust end point to be slightly into the pig (simulate going into piggy bank)
  const adjustedEnd = {
    x: end.x,
    y: end.y + 20,
  };

  // Return path as array of points for GSAP MotionPath
  return [
    { x: start.x, y: start.y },
    { x: peak.x, y: peak.y },
    { x: adjustedEnd.x, y: adjustedEnd.y },
  ];
};

gameController.playPresentAnimation = async function (reel, row, originalSymbol, revealedSymbols, sequentialIndex) {
  return new Promise((resolveShutter) => {
    const presentContainer = resourceManager.get('mainReelsContainer:presentAnimationContainer');
    // Ensure revealedSymbols is an array
    let coinSymbols = Array.isArray(revealedSymbols) ? revealedSymbols : [revealedSymbols];

    // Get the symbol position using the helper function
    let symbolPosition = helper.getCenterSymbolsPos(reel, row);

    // Get the symbol sprite and hide the present (show original underneath)
    let symbolSprite = resourceManager.get(
      'mainReelsContainer:slotContainer:reelContainer:reel' + reel + ':symbol' + row
    );

    // STEP 1: Create original symbol sprite FIRST (bottom layer) - but keep it hidden initially
    let originalSymbolSprite = gameController.createOriginalSymbolSprite(reel, row, originalSymbol, symbolPosition);

    // Ensure original symbol is at the back (bottom layer)
    if (originalSymbolSprite) {
      presentContainer.setChildIndex(originalSymbolSprite, 0);
      originalSymbolSprite.visible = true; // Make visible so it shows when present opens
    }

    // STEP 2: Create coin movies SECOND (middle layer)
    let coinMovies = [];

    // Only create coins if there are coins to reveal
    if (coinSymbols.length > 0) {
      for (let i = 0; i < coinSymbols.length; i++) {
        let coinSymbol = coinSymbols[i];
        let coinDefinition;
        switch (coinSymbol) {
          case 20:
            coinDefinition = 'RedCoinSpin';
            break;
          case 19:
            coinDefinition = 'GoldCoinSpin';
            break;
          case 18:
            coinDefinition = 'PurpleCoinSpin';
            break;
          case 17:
            coinDefinition = 'GreenCoinSpin';
            break;
          case 16:
            coinDefinition = 'OrangeCoinSpin';
            break;
          case 15:
            coinDefinition = 'BlueCoinSpin';
            break;
          case 14:
            coinDefinition = 'BlueCoinSpin';
            break;
          case 13:
            coinDefinition = 'GreenCoinSpin';
            break;
          case 12:
            coinDefinition = 'GoldCoinSpin';
            break;
          case 11:
            coinDefinition = 'RedCoinSpin';
            break;
          default:
            coinDefinition = 'BlueCoinSpin';
            break;
        }

        // Create resource name based on position and coin type for reusability
        const coinMovieName = coinDefinition + '_' + reel + '_' + row;

        // Check if this coin resource already exists
        let coinMovie = resourceManager.get('mainReelsContainer:symbolOverlayDisplay:' + coinMovieName);
        if (coinMovie) {
          coinMovie.visible = false;
        } else {
          coinMovie = resourceManager.createObject('movie', coinMovieName, gameController.symbolOverlayDisplay, {
            definition: coinDefinition,
            scale: 0.5,
            anchor: 0.5,
            visible: false,
          });
        }

        if (coinMovie) {
          // Set position only for newly created coin movies
          // Space them out if there is more than one
          let offsetX = (i - (coinSymbols.length - 1) / 2) * 30; // 30 pixel spacing between coins
          coinMovie.x = symbolPosition.x + offsetX;
          coinMovie.y = symbolPosition.y;

          coinMovie.visible = false;
          // Ensure coins are in middle layer (after original symbol)
          gameController.symbolOverlayDisplay.setChildIndex(coinMovie, coinMovies.length + 1);
          coinMovies.push(coinMovie);
        }
      }
    }

    // STEP 3: Create present spine animation LAST (top layer)
    const presentSpineName = 'PresentAnimation_' + reel + '_' + row;

    // Check if this present spine resource already exists
    let presentSpine = resourceManager.get('mainReelsContainer:presentAnimationContainer:' + presentSpineName);
    if (presentSpine) {
      presentSpine.visible = true;
    } else {
      presentSpine = resourceManager.createObject(
        'spine',
        presentSpineName,
        'mainReelsContainer:presentAnimationContainer',
        {
          name: 'Present',
          defaultAnimation: 'Present_Reveal_Anim',
          scaleX: 1.0,
          scaleY: 1.0,
        }
      );

      if (presentSpine) {
        presentSpine.x = symbolPosition.x;
        presentSpine.y = symbolPosition.y;
      }
    }

    presentSpine.visible = true;

    if (presentSpine.anchor) {
      presentSpine.anchor.set(0.5, 0.5);
    }

    presentContainer.setChildIndex(presentSpine, presentContainer.children.length - 1);

    let animationCompleted = false;
    const completionHandler = async () => {
      if (!animationCompleted) {
        animationCompleted = true;

        // Hide the present spine animation after it completes
        presentSpine.visible = false;

        // NOW show the reel symbol
        symbolSprite.visible = true;

        // Hide the overlay symbol since the reel symbol is now correct
        if (originalSymbolSprite) {
          originalSymbolSprite.visible = false;
        }

        // Return coin data for processing
        resolveShutter({ coinMovies, coinSymbols });
      }
    };

    // Change reel symbol from present to original
    let reelContainer = resourceManager.get('mainReelsContainer:slotContainer:reelContainer:reel' + reel);
    if (reelContainer) {
      reelContainer.setReelSymbol(row, originalSymbol);
    }
    // Hide the static present symbol
    symbolSprite.visible = false;

    // Start the present animation
    const spineSpeedModifier = 1.3;
    presentSpine.spineObject.state.timeScale = spineSpeedModifier;
    presentSpine.play('Present_Reveal_Anim', false, 0, completionHandler);

    // Make coins visible exactly when the present box starts opening (1.2s into animation)
    timerManager.addTimeout(1200 * (1 / spineSpeedModifier), () => {
      for (let j = 0; j < coinMovies.length; j++) {
        let coinMovie = coinMovies[j];
        if (coinMovie) {
          if (!soundManager.isSoundPlaying('coinReveal')) {
            soundManager.play('coinReveal');
          }

          coinMovie.visible = true;
          coinMovie.gotoAndPlay(0);
        }
      }
    });
  });
};

// Start the processing of all the coins found in shutters
moveCoinsToPots = async function (coins, coinSymbols, delayInMS = 0) {
  // Animate each coin to its destination (pig or jackpot trail)
  // Coins are already visible and spinning from when shutter opened
  if (!gameController.inFreeSpins) {
    const promises = [];
    for (let j = 0; j < coins.length; j++) {
      let coinMovie = coins[j];
      let coinSymbol = coinSymbols[j];

      // await timerManager.delayAsync(delay);
      const delay = delayInMS + 300 * j;
      promises.push(moveCoinToPot(coinMovie, coinSymbol, delay));
    }

    await Promise.all(promises);
  } else {
    gameController.movingCoinsToJackpots = true;

    // Free spins - process coins sequentially
    for (let j = 0; j < coins.length; j++) {
      // Check if win cap was hit - if so, hide remaining coins and stop processing
      if (gameController.winCapHit) {
        // Hide all remaining unprocessed coins
        for (let k = j; k < coins.length; k++) {
          const coinMovie = coins[k];
          if (coinMovie && coinMovie.visible) {
            coinMovie.visible = false;
            coinMovie.gotoAndStop(0);
          }
        }
        // Stop processing any more coins
        break;
      }

      let coinMovie = coins[j];
      let coinSymbol = coinSymbols[j];

      await moveCoinToPot(coinMovie, coinSymbol);
    }

    gameController.movingCoinsToJackpots = false;
  }
};

gameController.waitForAllPigUpdatesToFinish = async function () {
  console.log('gameController.waitForAllPigUpdatesToFinish');
  gameController.waitingForPigUpdatesToFinish = true;
  await Promise.all([
    gameController.updatingGreenPigPromise,
    gameController.updatingRedPigPromise,
    gameController.updatingGoldPigPromise,
    gameController.updatingBluePigPromise,
  ]);
  gameController.waitingForPigUpdatesToFinish = false;
  console.log('gameController.waitForAllPigUpdatesToFinish - done');
};

updatePigsAfterCoin = async function (pigColor, instant = false) {
  if (pigColor === 'red') {
    // this is working - we have the right data here!!!
    const data = {
      redPigLevel: gameController.spinTask.data.pendingDisplayStateUpdate.postBase.afterPart.freeSpinsDisplayLevelIndex,
      freeSpinsNum: gameController.spinTask.data.pendingDisplayStateUpdate.postBase.afterPart.numFreeSpins,
    };
    console.log('updating red pig after coin finished', data);
    gameController.updatingRedPigPromise = gameController.updateRedPig(data, instant);
    console.log('updated red pig after coin finished');
    // gameController.spinTask.data.pendingDisplayStateUpdate.postBase.afterPart.numFreeSpins
  } else if (pigColor === 'green') {
    const data = {
      greenPigLevel:
        gameController.spinTask.data.pendingDisplayStateUpdate.postBase.afterPart.eliminationsDisplayLevelIndex,
      eliminationLevel: gameController.spinTask.data.pendingDisplayStateUpdate.postBase.afterPart.eliminationLevel,
    };
    console.log('updating green pig after coin finished', data);
    gameController.updatingGreenPigPromise = gameController.updateGreenPig(data, instant);
    console.log('updated green pig after coin finished');
  } else if (pigColor === 'blue') {
    const data = {
      bluePigLevel: gameController.spinTask.data.pendingDisplayStateUpdate.postBase.afterPart.jpSpinsDisplayLevelIndex,
    };
    console.log('updating blue pig after coin finished', data);
    gameController.updatingBluePigPromise = gameController.updateBluePig(data, instant);
    // we need to wait for this one to finish
    // need to update the pots just after the pig gets there
    // await gameController.updatingBluePigPromise;
    console.log('updated blue pig after coin finished');
  } else if (pigColor === 'gold') {
    const data = {
      awardedPigs: gameController.spinTask.data.pendingDisplayStateUpdate.postBase.afterPart.numWheelUpgrades,
      goldPigLevel: gameController.spinTask.data.pendingDisplayStateUpdate.postBase.afterPart.wheelDisplayLevelIndex,
    };
    console.log('updating gold pig after coin finished', data);
    gameController.updatingGoldPigPromise = gameController.updateGoldPig(data, instant);
    console.log('updated gold pig after coin finished');
  }
};

// Show the win cap popup and wait for user to click continue
gameController.showWinCapPopup = async function () {
  return new Promise((resolve) => {
    const msgBoxPopupContainer = resourceManager.getContainer('msgBoxPopupContainer');
    const maxWinPopup = resourceManager.get('maxWinPopup');
    const skipButton = msgBoxPopupContainer.getChildByName('skipButton');

    // Set up skip button click handler (click anywhere to continue)
    const onSkipClick = () => {
      soundManager.play('buttonPressed');
      // Clean up handlers
      skipButton.mousedown = null;
      skipButton.touchstart = null;
      skipButton.interactive = false;

      // Animate popup scale back to 0
      gsap.to(maxWinPopup.scale, {
        duration: 0.5,
        x: 0,
        y: 0,
        ease: 'power1.inOut',
        onComplete: () => {
          maxWinPopup.visible = false;
          maxWinPopup.scale.set(1);
          resolve();
        },
      });

      // Fade out dark overlay
      gsap.to(skipButton, {
        duration: 0.5,
        alpha: 0,
        ease: 'none',
        onComplete: () => {
          skipButton.visible = false;
          skipButton.alpha = 1;
        },
      });
    };

    // Make containers visible
    msgBoxPopupContainer.visible = true;
    maxWinPopup.visible = true;
    skipButton.visible = true;

    // Start with scale 0 and alpha 0
    maxWinPopup.scale.set(0);
    skipButton.alpha = 0;

    // Animate scale from 0 to 1
    gsap.to(maxWinPopup.scale, {
      duration: 0.5,
      x: 1,
      y: 1,
      ease: 'power1.inOut',
      onComplete: () => {
        maxWinPopup.scale.set(1);
        // Make skip button interactive after animation completes
        skipButton.interactive = true;
        skipButton.mousedown = skipButton.touchstart = onSkipClick;
      },
    });

    // Fade in dark overlay
    gsap.to(skipButton, {
      duration: 0.5,
      alpha: 1,
      ease: 'none',
      onComplete: () => {
        skipButton.alpha = 1;
      },
    });
  });
};

// Move an individual coin and process it
moveCoinToPot = async function (coinMovie, coinSymbol, delayInMS = 0) {
  console.log('moveCoinToPot', delayInMS);
  return new Promise((resolve) => {
    if (coinMovie && gameController.pigPositions[coinSymbol]) {
      // Store original position and scale before animation
      let originalX = coinMovie.x;
      let originalY = coinMovie.y;
      let originalScaleX = coinMovie.scale.x || 0.5;
      let originalScaleY = coinMovie.scale.y || 0.5;
      let targetPosition = gameController.pigPositions[coinSymbol];

      let jackpotCoin = false;
      if (
        gameController.inFreeSpins &&
        (gameController.featureType === 2 ||
          gameController.featureType === 4 ||
          gameController.featureType === 6 ||
          gameController.featureType === 7)
      ) {
        targetPosition = gameController.jackpotView.getNodeXY(coinSymbol, coinMovie);
        jackpotCoin = true;
      }

      // Calculate parabolic path from coin to pig
      const startPoint = { x: originalX, y: originalY };
      const parabolicPath = gameController.calculateParabolicPath(startPoint, targetPosition);

      // Use GSAP to animate coin along parabolic path with scale reduction
      const scaleTween = gsap.to(coinMovie.scale, {
        delay: delayInMS / 1000,
        duration: 0.6,
        x: originalScaleX * gameController.pigPositions[coinSymbol].scale,
        y: originalScaleY * gameController.pigPositions[coinSymbol].scale,
        ease: 'power2.out',
      });

      // Animate position along parabolic path
      let coinWhooshSoundID = undefined;
      const moveTween = gsap.to(coinMovie, {
        delay: delayInMS / 1000,
        duration: 0.6,
        motionPath: {
          path: parabolicPath,
          autoRotate: false,
          alignOrigin: [0.5, 0.5],
        },
        ease: 'power2.out',
        onStart: () => {
          coinWhooshSoundID = soundManager.play('coinWhoosh');
        },
        onComplete: async () => {
          // soundManager.stop(coinWhooshSoundID);
          // Hide this coin when it reaches the pig
          coinMovie.visible = false;

          // Track coin delivery to pig - only in base game
          if (gameController.displayState && !gameController.inFreeSpins) {
            const pigColor = gameController.displayState.getPigFromCoinSymbol(coinSymbol);
            if (pigColor && gameController.pigCoinCounts[pigColor] !== undefined) {
              gameController.pigCoinCounts[pigColor]++;
            }

            // this is also where we should update the pig display, e.g. for red pig, update the number of free spins
            // this function doesnt always await, it store promises
            // but it will only really wait in there for the blue coin
            soundManager.play('coinPiggyBank');
            await this.updatePigsAfterCoin(pigColor, gameController.skipCurrentPiggieAnims);
          } else if (
            gameController.inFreeSpins &&
            (gameController.featureType === 2 ||
              gameController.featureType === 4 ||
              gameController.featureType === 6 ||
              gameController.featureType === 7)
          ) {
            // Light up jackpot trail node and wait for completion

            const soundToPlay = {
              20: 'coinLandAtMega',
              19: 'coinLandAtPorker',
              18: 'coinLandAtMajor',
              17: 'coinLandAtMaxi',
              16: 'coinLandAtMinor',
              15: 'coinLandAtMini',
            };

            soundManager.play(soundToPlay[coinSymbol]);

            const winCapTriggered = await gameController.jackpotView.lightUpJackpotTrailNode(coinSymbol);

            // Check if win cap was triggered
            if (winCapTriggered) {
              // Show the win cap popup and wait for user to click continue
              await gameController.showWinCapPopup();

              // Set flag to stop processing remaining coins
              gameController.winCapHit = true;
            }
          }

          // Reset coin position and scale back to original for reuse
          coinMovie.x = originalX;
          coinMovie.y = originalY;
          coinMovie.scale.x = originalScaleX;
          coinMovie.scale.y = originalScaleY;

          // Resolve the promise now that the coin animation has completed
          resolve();
        },
      });
      if (jackpotCoin) {
        // we only want to store the coins tweens
        // when we are in free spins - these are done one after the other
        // also the place where they move to are different so we need to stop early
        // on rotation
        gameController.jackpotTrailCoinScaleTween = scaleTween;
        gameController.jackpotTrailCoinMoveTween = moveTween;
      } else {
        // in base game we can have multiple coins running
        // and the final position is the same regardless of orientation
        gameController.movingCoinsToPigsTweens.push({
          scale: scaleTween,
          move: moveTween,
        });
        gameController.jackpotTrailCoinScaleTween = undefined;
        gameController.jackpotTrailCoinMoveTween = undefined;
        // so perhaps we should store 1 for each coloured coin
        // and we can tell the tweens to finish earlier on the next slam stop?
        // or we have multi phase skip, 1 for coins, 1 for wins
      }
    } else {
      // Coin or position did not exist
      resolve();
    }
  });
};

// this will be called when there is a win
gameController.handleSoundLevel = function () {
  if (!gameController.inFreeSpins) {
    if (!gameController.spinTask.data.wheelWon) {
      musicManager.handleBasegameSoundLevel(gameController.spinHasWin);
    }
  } else {
    musicManager.handleFreeSpinsSoundLevel(gameController.totalWinnings);
  }
};

gameController.onSpinLand = function (reel) {
  // if (gameData.reelsSpinning === 0) {
  //   soundManager.stop(gameController.currentReelSpin);
  // }
};

gameController.onSpinHit = function (reel, isSlamStop = false) {
  if (reel === gameData.LAST_REEL_INDEX) {
    if (gameController.featureSkipWinDisplay && gameController.lastPayWinsData === undefined) {
      for (let i = 0; i < 5; i++) {
        gameController.dimFullReel(i, false, 0.2);
      }
    }

    gameController.bonusAntipationActive = false;
  }

  if (!gameController.inFreeSpins) {
    gameController.symbolFrameDisplay.stopAnticipationAnim(reel, 0.5);
  }
};

gameController.startGame = function () {
  // Do not allow the user to spin if the buy bonus or autoplay dialog is visible
  let buyBonusPopUp = resourceManager.get('buyABonusContainer:buyBonusPopup');
  let autoplayPopUp = resourceManager.get('autoplayContainer:autoplayBacker');

  if (buyBonusPopUp.visible || autoplayPopUp.visible) return;

  gameController.justHadFreeSpins = false;

  gameController.initNewGame();

  const stakeController = resourceManager.getController('stakeController');
  let bpl = stakeController.BaseStake / stakeController.CurrentWinLineCount;

  gdk.startGame(
    {
      stake: stakeController.CurrentStake,
      numWinlines: stakeController.CurrentWinLineCount,
      bpl: bpl,
      metaData: {
        buyABonus: false,
        encore: gameData.encoreEnabled,
      },
    },
    function () {
      gdk.getNextGameOutcome(function () {});
    }
  );
};

gameController.stopCyclingWins = function () {
  gameController.cyclingWins = false;
  gameController.symbolAnimator.skip();
  gameController.symbolAnimatorLow.skip();
  gameController.lastPayWinsData = undefined;
  gameController.cyclingWinsIndex = 0;
  gameController.symbolFrameDisplay.stopSymbolFrameAnims();
  gameController.hideCycleWinPanelContainer();
};

gameController.setState_WaitingForServer = function (eventToLeave) {
  if (!gameController.inFreeSpins) {
    // Only monitor how long we are waiting for server if we arent in freespins
    gameController.stateMachine.switchState('WAITING_FOR_SERVER');
  }
  if (checkForDefined(eventToLeave)) {
    eventToLeave.leave();
  }
};

gameController.autoplayStarted = function (autoplayData) {
  autoplayManager.dialog.buttonGlow = resourceManager.get('buttonContainer:buttonBar:autoplayButton:glow');

  autoplayManager.dialog.buttonGlow.visible = true;
};

gameController.autoplayEnded = function (autoplayData) {
  resourceManager.getController('inputOverlord').setText('autoplayCancelButton', '');

  resourceManager.get('buttonContainer:buttonBar:autoplayButton:glow').visible = false;
};

StateMachine.Create(gameController);

gameController.stateMachine.addState('WAITING_FOR_LOAD', function () {});

gameController.cancelAutoplay = function () {
  if (autoplayManager.isAutoplayEnabled()) {
    gdk.cancelAutoplay();
    messageBus.postImmediate('autoplay:ended');
  }
};

gameController.stateMachine.addState('WAITING_FOR_REELS', function () {
  if (gameController.phase.hold()) {
    if (gameController.spinComplete) {
      gameController.phase.step();
    }
  }
  if (gameController.phase.once()) {
    gameController.stateMachine.switchState('WAITING_FOR_BONUSES');
  }
});

// gameController.stateMachine.addState('WAITING_FOR_JACKPOT', function () {
//   if (gameController.phase.once()) {
//     gameController.presentJackpots();
//   }
//
//   if (gameController.phase.hold()) {
//     if (gameController.jackpotsPresented === true) {
//       gameController.phase.step();
//     }
//   }
//
//   if (gameController.phase.once()) {
//     gameController.setState_WaitingForServer(gameController.spinTask);
//   }
// });

gameController.stateMachine.addState('WAITING_FOR_BONUSES', async function () {
  if (gameController.phase.hold()) {
    if (gameController.shutterAnimationsComplete) {
      gameController.phase.step();
    }
  }
  if (gameController.phase.once()) {
    console.log('Switching to state to waiting for server');
    // if (gameController.areThereJackpotsToAward) {
    //   gameController.switchState('WAITING_FOR_JACKPOT');
    // } else {
    gameController.setState_WaitingForServer(gameController.spinTask);
    // }
  }
});

gameController.stateMachine.addState('WAITING_FOR_START', function () {
  if (gameController.phase.hold()) {
    if (!resourceManager.getController('autoplayController').LimitPopupOpen) {
      gameController.phase.step();
    }
  }

  if (gameController.phase.once()) {
    if (!autoplayManager.isAutoplayEnabled() && !gameController.justHadFreeSpins) {
      // Only start win cycling if shutter animations are complete
      if (gameController.shutterAnimationsComplete) {
        gameController.cyclingWins = true;
        gameController.cycleWins();
      } else {
      }
    }
  }

  if (gameController.phase.hold()) {
    // Waiting for player to do something
    if (autoplayManager.isAutoplayEnabled()) {
      if (autoplayManager.AP.getFields()['numberOfRounds'].currentValue !== autoplayManager.AP.roundsRemaining()) {
        var timeToNext = 500;
        resourceManager.getController('autoplayController').timeToNextAutoplay = timeToNext;
        gameController.phase.step();
      }
    }
  }

  if (gameController.phase.timed(resourceManager.getController('autoplayController').timeToNextAutoplay)) {
  }

  if (gameController.phase.once()) {
    gameController.startGame();
    if (autoplayManager.AP.roundsRemaining() === 0) {
      // Last round, so cancel autoplays
      gameController.cancelAutoplay();
    }
  }
});

gameController.stateMachine.addState('SPIN_REELS_SPINNING', function () {});

gameController.stateMachine.addState('COIN_FRENZY', function () {
  if (gameController.phase.once()) {
    // present coin frenzy animation
    gameController.coinFrenzyAnimation.presentCoinFrenzyAnimation();
  }

  if (gameController.phase.hold()) {
    if (gameController.coinFrenzyAnimation.hasAnimFinished() === true) {
      // move onto next step
      gameController.phase.step();
    }
  }

  if (gameController.phase.once()) {
    // now its ok to tell the reels to stop
    // Set up data for the reels
    const symbols = [];
    const above = [];
    const below = [];
    for (let reel = 0; reel < gameController.spinTask.data.resultPanel.reelList.length; reel++) {
      symbols.push([]);
      above.push([]);
      below.push([]);
      for (let row = 0; row < gameController.spinTask.data.resultPanel.reelList[reel].symbols.length; row++) {
        symbols[reel].push(gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value);
      }
    }
    gameController.stateMachine.switchState('SPIN_REELS_SPINNING');
    if (gameController.dynamicSpinner) {
      spinController.stopSpin(symbols, above, below, gameController.onSpinComplete);
    } else {
      gameController.slotMachine.stopReels(symbols, above, below, gameController.onSpinComplete);
    }
    gameController._coinFrenzyDelaySlamStop = false;
  }
});

gameController.stateMachine.addState('WAITING_FOR_SERVER', function () {});

gameController.stateMachine.addState('PAYING_TO_WINNINGS', function () {
  if (gameController.phase.enter()) {
    winMeter.meter.cancelCountUp();

    soundManager.play('winCountUp');
  }
  if (gameController.phase.hold()) {
    if (!gameData.winningsMeter.Props.isCounting) {
      // Finished counting
      if (!gameData.slotConfig.promotionActive) {
        resourceManager.get('winningsMeterLabel').visible = true;
      }

      gameController.unFadeSymbols();

      gameController.stateMachine.switchState('DELAY_SHOW_WINNINGS');

      soundManager.stop('winCountUp');
      soundManager.play('winCountUpEnd');
    } else {
      if (!gameData.slotConfig.promotionActive) {
        resourceManager.get('winningsMeterLabel').visible = gameController.gameTime % 200 < 100;
      }
    }
  }

  if (gameController.phase.exit()) {
    if (!gameData.slotConfig.promotionActive) {
      resourceManager.get('winningsMeterLabel').visible = true;
    }
  }
});

gameController.stateMachine.addState('GAME_PLAYING', function () {
  if (gameController.phase.enter()) {
  }
});

gameController.stateMachine.addState('GAME_ENDED', function () {
  if (gameController.phase.enter()) {
  }
  if (gameController.phase.once()) {
    gdk.endGame(function () {
      if (!gameData.mainTunePlaying && !gameController.inFreeSpins) {
        gameData.mainTunePlaying = true;
      }
      gameController.stateMachine.switchState('WAITING_FOR_START');
      gameController.baseSpin = true;
    });
  }
});

gameController.stateMachine.switchState('WAITING_FOR_LOAD');

gameController.update = function (delta, time) {
  gameController.stateMachine.update();
};

gameController.displayBonusEntryAnims = function (loopCount, callback = undefined) {
  soundManager.play('bonusWon');
  gameController.loopBonusAnim(gameController.bonusSymbols, 14, loopCount, 1020, callback);
};

gameController.cycleWins = function (once, callback) {
  if (gameController.cyclingWins) {
    if (gameController.lastPayWinsData !== undefined && gameController.lastPayWinsData.winningLines !== undefined) {
      gameController.cyclingWinsIndex = 0;
      gameController.cycleWin();
    }
  }
};

gameController.showCycleWinPanelContainer = function (data) {
  gameController.cycleWinLine.setTranslationParameters(data.winningLine);
  gameController.cycleWinSymbol.gotoAndStop(data.symbol.value);
  gameController.cycleWinMulti.setText(`x${data.positions.length}`);
  gameController.cycleWinValue.setText(gdk.formatCurrency(data.winAmount));
  if (gameController.cycleWinPanelContainer.visible === false) {
    gameController.cycleWinPanelContainer.visible = true;
    gameController.cycleWinPanelContainer.alpha = 0;
    gsap.fromTo(
      gameController.cycleWinPanelContainer,
      {
        alpha: 0,
      },
      {
        duration: 0.25,
        alpha: 1,
      }
    );
    gsap.fromTo(
      gameController.cycleWinPanel,
      {
        y: 75,
      },
      {
        duration: 0.75,
        ease: 'elastic.out',
        y: 0,
      }
    );
  }
};

gameController.hideCycleWinPanelContainer = function () {
  if (gameController.cycleWinPanelContainer.visible === true) {
    gameController.cycleWinPanelContainer.alpha = 0;
    gsap.fromTo(
      gameController.cycleWinPanelContainer,
      {
        alpha: 1,
      },
      {
        duration: 0.15,
        alpha: 0,
        onComplete: () => {
          gameController.cycleWinPanelContainer.visible = false;
        },
      }
    );
    gsap.fromTo(
      gameController.cycleWinPanel,
      {
        y: 0,
      },
      {
        duration: 0.15,
        ease: 'none',
        y: 75,
      }
    );
  }
};

gameController.cycleWin = function () {
  let canCelebrate = this.lastPayWinsData.totalLineWinnings > gameController.getCurrentModeStake();

  if (gameController.lastPayWinsData.winningLines.length !== 0) {
    gameController.symbolAnimating = true;

    let data = gameController.lastPayWinsData.winningLines[gameController.cyclingWinsIndex];

    gameController.showCycleWinPanelContainer(data);

    let symbols = [];

    for (let i = 0; i < data.positions.length; ++i) {
      symbols.push({
        cell: { reel: data.positions[i].reel, row: data.positions[i].row },
        symbolId: data.symbol.ids[i],
      });
    }

    if (canCelebrate) {
      spineSymbolAnimator.animate(symbols, gameController.cycleWinDelay.bind(this), 0);
    } else {
      gameController.symbolAnimatorLow.animateSymbols(symbols, gameController.slotMachine, true, false, function () {
        gameController.cycleWinDelay();
      });
    }

    let frameData = {
      winningLines: [gameController.lastPayWinsData.winningLines[gameController.cyclingWinsIndex]],
    };

    // if (data.symbol.value !== 14 && data.symbol.value !== 15) {
    //   gameController.displaySymbolFrames(frameData);
    // }
    gameController.displaySymbolFrames(frameData);

    gameController.animating = true;

    // All symbols and symbol frames take a second - NO THEY DONT!!!!! NEW SPINE ANIMS HAVE DIFFERENT LENGTHS!!!
    timerManager.addTimeout(1000, function () {
      gameController.animating = false;
      gameController.symbolAnimating = false;
      gameController.symbolAnimator.skip();
      gameController.symbolAnimatorLow.skip();
    });
  }
};

gameController.cycleWinDelay = function () {
  timerManager.addTimer(1000, undefined, function () {
    gameController.symbolAnimating = false;
    gameController.cycleNextWin();
  });
};

gameController.cycleNextWin = function () {
  if (
    gameController.cyclingWins &&
    !gameController.symbolAnimating &&
    !gameController.animating &&
    gameController.lastPayWinsData &&
    gameController.lastPayWinsData.winningLines
  ) {
    ++gameController.cyclingWinsIndex;

    if (gameController.cyclingWinsIndex < gameController.lastPayWinsData.winningLines.length) {
      gameController.cycleWin();
    } else {
      gameController.cycleWins();
    }
  }

  gameController.muteCyclingWins = true;
};

gameController.onLimitsPopupClosed = function () {
  soundManager.play(gameData.sounds.buttonPressed);
  gameController.stateMachine.switchState('GAME_ENDED');
};

gameController.onStakeChanged = function (stake) {
  const currentStake = gameData.stakes[gameData.currentStakeIndex];

  if (stake !== undefined && currentStake !== stake) {
    if (!gameData.ignoreResetWinningsMeterOnStakeChange) {
      gameData.winningsMeter.set(0);
    }
    gameData.ignoreResetWinningsMeterOnStakeChange = false;

    gameController.totalWinnings = 0;

    gameController.stopCyclingWins();

    game.changeStake(stake);

    gameController.displayStakeChangeMessage();
  }

  gameController.currentStake = stake;
  gameData.currentStakeIndex = gameData.stakes.indexOf(stake);

  if (!gdk.getServerParser().addingRecoveryToQueue && !gameController.tempIgnoreUpdateCountersBecauseOfRestore) {
    gameController.updateCounterState(stake);
    gameController.updateCounters(gameController.getCurrentPersistentStateData(stake), false, true);
  }
};

gameController.displayStakeChangeMessage = function () {
  if (gameController.piggiesChanged === true) {
    gameController.piggiesChanged = false;
    let panel = resourceManager.get('stakeChangeContainer');
    panel.visible = true;
    panel.alpha = 1;
    if (gameController.stakeChangeAnim !== undefined) {
      gameController.stakeChangeAnim.kill();
    }
    gameController.stakeChangeAnim = gsap.to(panel, {
      delay: 3,
      duration: 1.0,
      alpha: 0,
      ease: 'none',
      onComplete: () => {
        panel.visible = false;
      },
    });
  }
};

gameController.onGameComplete = function (task) {
  // Update persistent values if they were sent with the game complete event
  if (task && task.data && task.data.persistentValues) {
    gameController.persistentValues = task.data.persistentValues;
    console.log('Updated gameController persistent values from server:', gameController.persistentValues);
  }

  // Output cumulative coin counts after each spin
  // console.log(
  //   `%c--- CUMULATIVE COIN COUNTS AFTER SPIN ---`,
  //   `color: #FF0000; font-weight: bold; font-size: 16px; background: white; padding: 4px; text-shadow: 2px 2px 4px rgba(0,0,0,0.5);`
  // );
  // console.log('Red pig coins: ', gameController.pigCoinCounts.red);
  // console.log('Blue pig coins: ', gameController.pigCoinCounts.blue);
  // console.log('Green pig coins: ', gameController.pigCoinCounts.green);
  // console.log('Gold pig coins: ', gameController.pigCoinCounts.gold);
  // console.log('');

  if (gameController.featureSkipWinDisplay && gameController.totalWinnings > 0) {
    gameController.fullWinningsDisplay.displayWinnings(
      gameController.totalWinnings,
      gameController.inFreeSpins,
      () => {
        gameController.endGame();
        // musicManager.returnMusic();
      },
      gameController.inBuyABonus
    );
  } else {
    gameController.endGame();
    // musicManager.returnMusic();
  }
};

gameController.endGame = function () {
  if (gameController.inBuyABonus) {
    // keep the buy bonus stake
    const sp = gdk.getServerParser();
    const inReplayOrRewatch = sp._inReplayMode || sp._inRewatchMode;
    if (!inReplayOrRewatch) {
      gameController.inBuyABonus = false;
      gameController.buyBonusHigh = false;
      gameController.buyBonusLow = false;
      gameController.buyBonusMystery = false;

      let returnStake = gameData.bonusBuyStake;

      const stakeController = resourceManager.getController('stakeController');
      // now we can have bonus buys on different stakes compared to normal
      // so 1st lets make sure the stake is valid for BASIC
      const stakeIndex = stakeController.Stakes.indexOf(returnStake);
      if (stakeIndex === -1) {
        // the bonus buy stake isnt in the BASIC stake
        // so we need to use the default
        // this is assuming default stake has been set correctly :( as everything appears to be in closures!!
        if (!gameController.currentNonBABStake) {
          returnStake = stakeController.BaseStake;
        } else {
          returnStake = gameController.currentNonBABStake;
        }
        gameData.ignoreResetWinningsMeterOnStakeChange = true;
      }

      // const stakeController = resourceManager.getController('stakeController');
      // if (!gameController.currentNonBABStake) {
      //   gameController.currentNonBABStake = stakeController.getBaseStake('default');
      // }
      gameController.currentNonBABStake = returnStake;
      stakeController.requestChangeStake(gameController.currentNonBABStake);
      game.changeStake(gameController.currentNonBABStake);

      gameController.updateCounterState(gameController.currentNonBABStake);
      gameController.updateCounters(gameController.getCurrentPersistentStateData(gameController.currentNonBABStake));
    }
  }

  // if we are a prepaid, we shouldnt be including the total winnings
  // how do we know if we are a prepaid?
  // if (!gameController.isPrePaid && !gdk.serverParser._inReplayMode) {
  //   gameData.creditMeter.set(gameData.credit + gameController.totalWinnings);
  // }

  gdk.endGame(function () {
    if (!gameData.mainTunePlaying && !gameController.inFreeSpins) {
      gameData.mainTunePlaying = true;
    }
    resourceManager.getController('autoplayController').checkLimits();
    // Check again in case we just cancelled autoplay
    if (autoplayManager.isAutoplayEnabled() === false) {
      resourceManager.getController('inputOverlord').setState('enabled');

      gameController.stateMachine.switchState('WAITING_FOR_START');
    } else {
      // Next game is AUTOPLAY
      gameController.stateMachine.switchState('WAITING_FOR_START');
    }

    musicManager.onGameEnd(gameController.fullWinningsDisplay._bigWinLevel);
    gameController.fullWinningsDisplay._bigWinLevel = -1;
  });
};

gameController.doSlamStop = function () {
  if (gameController.movingCoinsToJackpotAndUpdatingValues) {
    console.log('doSlamStop - movingCoinsToJackpotAndUpdatingValues is true');
    gameController.skipMovingCoinsToJackpotPanels();
  }
  musicManager.stopSpinButtonSound();
  // if (gameController.currentReelSpin !== undefined) soundManager.stop(gameController.currentReelSpin);

  gameController.bonusAntipationActive = false;

  for (let i = 0; i < gameData.reels.length; i++) {
    gameController.symbolFrameDisplay.stopAnticipationAnim(i, 0.0);
    gameController.onSpinHit(i, true);
  }

  if (gameData.reelsSpinning > 0) {
    spinController.longSpinMainReels = [false, false, false, false, false];

    gameController.slamStopped = true;
    // gameController.symbolLandAnimator.skip();
    soundManager.stop('reelSpinLoop');

    gameController.reelsToSlam = [];
    for (let i = 0; i < gameData.reels.length; ++i) {
      gameController.reelsToSlam.push(i);
      gameController.playLandSounds(i);
    }

    gameController.slotMachine.slamReels(gameController.reelsToSlam);
  }
};

gameController.doPayWins = function (winTask) {
  gameController.winTask = winTask;
  gameController.winTask.join();

  gameController.slotMachine.clearDimSymbolIds();

  gameController.reelsPrize = winTask.data.totalLineWinnings;

  if (!gameController.inFreeSpins) {
    gameController.preFSReelPrize = gameController.reelsPrize;
    gameData.winningsMeter.add(gameController.winTask.data.totalLineWinnings);
    gameController.totalWinnings += gameController.winTask.data.totalLineWinnings;
  }

  const stake = gameController.getCurrentModeStake();

  const canCelebrate = gameController.winTask.data.totalLineWinnings > stake;

  gameController.lastPayWinsData = winTask.data;

  if (!gameController.inFreeSpins) {
    gameController.storedPayWinsData = JSON.parse(JSON.stringify(winTask.data));
  }

  let FiveOfAKindWins = false;

  for (let index = 0; index < winTask.data.winningLines.length && canCelebrate; index++) {
    const winLine = winTask.data.winningLines[index].positions;
    if (winLine.length > 4) {
      FiveOfAKindWins = true;
      break;
    }
  }

  if (FiveOfAKindWins && !gameController.winCapHit) {
    gameController.doFiveOfAKindWins(winTask);
  } else {
    timerManager.addTimeout(1, function () {
      gameController.skipWinsPanel.interactive = true;
      gameController.canSkipWin = true;
      gameController.dimNoneWinningSymbols(winTask.data.winningLines);
      gameController.displaySymbolFrames(gameController.winTask.data);

      // Start win animations immediately if no shutters are active
      gameController.startWinAnimations(stake);
    });
  }
};

gameController.doFiveOfAKindWins = function (winTask) {
  const stake = resourceManager.getController('stakeController').CurrentStake;
  gameController.FiveOfAKindText.visible = true;
  gameController.FiveOfAKindRay.visible = true;
  gameController.FiveOfAKindContainer.visible = true;
  gameController.screenDim.alpha = 0;
  gameController.screenDim.visible = true;
  gameController.FiveOfAKindText.position.y = -800;
  gameController.FiveOfAKindRay.position.y = 252;
  gameController.FiveOfAKindRay.scale = { x: 0, y: 0 };
  soundManager.play('fiveOfAKind');
  const rotationTween = gsap.to(gameController.FiveOfAKindRay, {
    duration: 6,
    rotation: Math.PI * 2,
    ease: 'linear',
    repeat: -1,
  });

  gsap.to(gameController.screenDim, {
    duration: 0.2,
    ease: 'power1.inOut',
    alpha: 1,
  });

  gsap
    .timeline()
    .to(gameController.FiveOfAKindText.position, {
      duration: 0.2,
      ease: 'power1.inOut',
      y: 300,
    })
    .to(gameController.FiveOfAKindText.position, {
      duration: 0.2,
      ease: 'power1.inOut',
      y: 290,
    })
    .to(gameController.FiveOfAKindText.position, {
      duration: 0.2,
      ease: 'power1.inOut',
      y: 300,
    })
    .to(gameController.FiveOfAKindText.position, {
      duration: 0.2,
      ease: 'power1.inOut',
      y: 310,
    })
    .to(gameController.FiveOfAKindText.position, {
      duration: 0.4,
      ease: 'power1.inOut',
      y: 800,
      onStart: () => {
        gsap.to(gameController.FiveOfAKindRay.position, {
          duration: 0.4,
          ease: 'power1.inOut',
          y: 800,
        });
      },
      onComplete: () => {
        rotationTween.kill();
        gsap.to(gameController.screenDim, {
          duration: 0.1,
          ease: 'power1.inOut',
          alpha: 0,
          onComplete: () => {
            gameController.screenDim.visible = false;
          },
        });
        gameController.FiveOfAKindRay.rotation = 0;
        gameController.FiveOfAKindText.visible = false;
        gameController.FiveOfAKindRay.visible = false;
        gameController.FiveOfAKindContainer.visible = false;
        timerManager.addTimeout(1, function () {
          gameController.skipWinsPanel.interactive = true;
          gameController.canSkipWin = true;
          gameController.dimNoneWinningSymbols(winTask.data.winningLines);
          gameController.displaySymbolFrames(gameController.winTask.data);

          // Start win animations immediately if no shutters are active
          gameController.startWinAnimations(stake);
        });
      },
    });
};

gameController.startWinAnimations = function (stake) {
  // Skip win animations if meter was already fully updated by win-capped jackpot
  if (gameController.meterFullyUpdated) {
    gameController.winlinePreAnimsDone();
    return;
  }

  if (!gameController.inFreeSpins) {
    gameController.handleSoundLevel();
  }

  if (gameController.winTask.data.totalLineWinnings > stake) {
    const batcher = gameController.winControllerMain._batcher;
    let sequenceData = batcher.batch(gameController.lastPayWinsData, true);

    musicManager.changeMusicVolume(musicManager.loweredMusicVolume);

    let bestSymbolWin = -1;
    for (let j = 0; j < sequenceData[0].length; ++j) {
      if (sequenceData[0][j].winId > bestSymbolWin) {
        bestSymbolWin = sequenceData[0][j].winId;
      }
    }

    musicManager.playWinForSymbol(bestSymbolWin);

    spineSymbolAnimator.animate(
      sequenceData[0],
      function () {
        musicManager.changeMusicVolume(musicManager.maxMusicVolume);
        gameController.winlinePreAnimsDone();
      },
      0
    );
  } else {
    soundManager.play('lowerThanStakeWin');

    gameController.winControllerMain.startAnimations(
      gameController.lastPayWinsData,
      resourceManager.getController('stakeController').CurrentStake,
      gameController.slotMachine,
      function () {
        // musicManager.changeMusicVolume(musicManager.maxMusicVolume);
        gameController.winlinePreAnimsDone();
      }
    );
  }
};

/*
 * This function replaces any winning symbols in the lastPayWinsData any present wilds
 * if they are in matching positions.
 */
// gameController.replaceWinSymbolsWithPresentWilds = function (lastPayWinsData, wildsPresent) {
//   // If we have no winning lines or no wilds present, return the data unchanged
//   if (!lastPayWinsData?.winningLines || !wildsPresent) {
//     return lastPayWinsData; // Return unchanged if data is invalid
//   }

//   // Create a copy to avoid modifying the original data
//   const updatedPayWinsData = JSON.parse(JSON.stringify(lastPayWinsData));

//   // Loop through each winning line
//   updatedPayWinsData.winningLines.forEach((winLine) => {
//     // Check each position in the winning line
//     winLine.positions.forEach((pos, posIndex) => {
//       // Look for a matching wild position
//       const matchingWild = wildsPresent.find((wild) => wild.coord.reel === pos.reel && wild.coord.row === pos.row);

//       // If a matching wild was found, replace the symbol ID at that position
//       if (matchingWild) {
//         winLine.symbol.ids[posIndex] = matchingWild.symbol;
//       }
//     });
//   });

//   return updatedPayWinsData;
// };

gameController.displaySymbolFrames = function (data) {
  let symbols = [];

  for (let i = 0; i < data.winningLines.length; i++) {
    for (let j = 0; j < data.winningLines[i].positions.length; j++) {
      const symbol = {
        reel: data.winningLines[i].positions[j].reel,
        row: data.winningLines[i].positions[j].row,
      };
      symbols.push(symbol);
    }
  }
  gameController.symbolFrameDisplay.stopSymbolFrameAnims();
  gameController.symbolFrameDisplay.playFrameAnims(symbols);
};

gameController.dimNoneWinningSymbols = function (winningLines) {
  // dim none winning symbols
  let winningPositions = [];
  for (let i = 0; i < winningLines.length; ++i) {
    let winningLine = winningLines[i];
    let positions = winningLine.positions;
    for (let j = 0; j < positions.length; ++j) {
      let cell = positions[j];
      winningPositions.push(cell.reel * 6 + cell.row);
    }
  }

  let symbolsToDim = [];
  for (let reel = 0; reel < 5; ++reel) {
    for (let row = 0; row < 3; ++row) {
      if (winningPositions.indexOf(reel * 6 + row) === -1) {
        symbolsToDim.push({ reel: reel, row: row });
      }
    }
  }

  gameController.slotMachine.dimSymbols(symbolsToDim, true);

  if (!gameController.inFreeSpins) {
    gameController.symbolOverlayDisplay.dimSymbols(symbolsToDim, true);
  }
};

gameController.winlinePreAnimsDone = function () {
  gameController.doBigWin();
};

gameController.doBigWin = function () {
  // If meter was fully updated by win-capped jackpot, skip win display entirely
  if (gameController.meterFullyUpdated) {
    gameController.bigWinDone();
    return;
  }

  let winnings = gameController.lastPayWinsData.totalLineWinnings;
  //let isBigWin = gameController.fullWinningsDisplay.willTriggerBigWin(winnings);

  if (winnings && (!gameController.featureSkipWinDisplay || gameController.inFreeSpins)) {
    gameController.winDisplayInProgress = true;
    // Store the win data to preserve it during display
    gameController.winDisplayData = winnings;
    gameController.fullWinningsDisplay.displayWinnings(
      winnings,
      gameController.inFreeSpins,
      () => {
        gameController.bigWinDone();
      },
      gameController.inBuyABonus
    );
  } else {
    gameController.bigWinDone();
    // musicManager.returnMusic();
  }
};

gameController.bigWinDone = function () {
  gameController.symbolFrameDisplay.stopSymbolFrameAnims();
  resourceManager.getContainer('DemoContainer').visible = true;

  // Use stored win data if lastPayWinsData was cleared during display
  const winAmount =
    gameController.winDisplayData ||
    (gameController.lastPayWinsData && gameController.lastPayWinsData.totalLineWinnings) ||
    0;

  // If meter has already been fully updated (e.g., by win-capped jackpot), skip all meter updates
  if (gameController.meterFullyUpdated) {
    gameController.bigWinFinished = true;
    gameController.winDisplayInProgress = false;
    gameController.winDisplayData = null;
    gameController.winlineAnimsDone();
    return;
  }

  if (gameController.inFreeSpins) {
    // soundManager.play('creditCountUp');
    gameData.winningsMeter.countUp(winAmount, 300, () => {
      // soundManager.stop('creditCountUp');
      // soundManager.play('creditCountUpEnd');
    });
    gameController.totalWinnings += winAmount;
    gameController.handleSoundLevel();
  } else {
    gameData.winningsMeter.set(winAmount);
    gameController.totalWinnings = winAmount;
  }

  gameController.bigWinFinished = true;
  gameController.winDisplayInProgress = false;
  gameController.winDisplayData = null; // Clear stored data

  gameController.winlineAnimsDone();
};

gameController.winlineAnimsDone = function () {
  gameController.slotMachine.clearDimSymbolIds();
  gameController.slotMachine.dimAllSymbols(false, 0.1);
  gameController.symbolOverlayDisplay.dimAllSymbols(false, 0.1);

  gameController.canSkipWin = false;
  gameController.skipWinsPanel.interactive = false;

  gameController.winTask.leave();
  gameController.winTask = undefined;
};

gameController.skipWinAnimations = function () {};

gameController.isAnimatingWins = function () {
  return gameController.winTask !== undefined;
};

gameController.skipWin = function () {
  if (gameController.winAnimationDelayTimer !== undefined) {
    timerManager.stop(gameController.winAnimationDelayTimer);
    gameController.winAnimationDelayTimer = undefined;
    gameController.winlineAnimsDone();
  }
  gameController.winControllerMain.skipAnimations();
  gameController.symbolAnimator.skip();
  gameController.symbolAnimatorLow.skip();
  gameController.symbolFrameDisplay.stopSymbolFrameAnims();

  gameController.skipWinsPanel.interactive = false;
  gameController.canSkipWin = false;

  spineSymbolAnimator.skip(true);

  gameController.skipWinReset();
};

gameController.skipMovingCoinsToPigsTweens = function () {
  if (Array.isArray(gameController.movingCoinsToPigsTweens)) {
    for (let i = 0; i < gameController.movingCoinsToPigsTweens.length; i++) {
      const tweens = gameController.movingCoinsToPigsTweens[i];
      if (tweens.scale && (tweens.scale.isActive() || tweens.scale.time() < tweens.scale.startTime())) {
        tweens.scale.totalProgress(1);
      }
      if (tweens.move && (tweens.move.isActive() || tweens.move.time() < tweens.move.startTime())) {
        tweens.move.totalProgress(1);
      }
    }
    gameController.movingCoinsToPigsTweens = [];
  }
};

gameController.skipMovingCoinsToJackpotPanels = function () {
  for (let i = 0; i < gameController.jackpotAssetsKeys.length; i++) {
    const asset = gameController.jackpotAssets[gameController.jackpotAssetsKeys[i]];
    if (asset.scaleTween && (asset.scaleTween.isActive() || asset.scaleTween.time() < asset.scaleTween.startTime())) {
      asset.scaleTween.totalProgress(1);
      asset.scaleTween = undefined;
    }
    if (asset.moveTween && (asset.moveTween.isActive() || asset.moveTween.time() < asset.moveTween.startTime())) {
      asset.moveTween.totalProgress(1);
      asset.moveTween = undefined;
    }
  }
};

gameController.skipWinsButtonPressed = function () {
  if (gameController.movingCoinsToPigs) {
    // base game - coins going to pigs
    console.log('gameController.skipWinsButtonPressed - movingCoinsToPigs');
    gameController.skipMovingCoinsToPigsTweens();
  } else if (gameController.movingCoinsToJackpotAndUpdatingValues) {
    // free spins blue feature
    console.log('gameController.skipWinsButtonPressed - movingCoinsToJackpots');
  } else {
    gameController.fullWinningsDisplay.skipPressed(false);
  }
};

gameController.skipWinReset = function () {};

gameController.doFeatureAwarded = function (task) {
  gameController.fsAwardedTask = task;
  gameController.fsAwardedTask.join();

  console.log('make pigs jump here');
  gameController.fsAwardedTask.leave();
  gameController.fsAwardedTask = undefined;
};

gameController.onFreespinsStart = function () {
  autoplayManager.stopAutoplay();
};

gameController.onFreespinsEnd = function () {
  // gameController.currentPersistentState = gameController.getPersistentValues(gameController.getCurrentModeStake());
  // gameController.updateCounterState(resourceManager.getController('stakeController').getCurrentStake());
  // gameController.updateCounters(gameController.getCurrentPersistentStateData());

  gameController.justHadFreeSpins = true;
  gameController.inFreeSpins = false;
  resourceManager.getController('inputOverlord').setState('enabled');
  // Ensure the game state machine transitions to WAITING_FOR_START after free spins end
  gameController.stateMachine.switchState('WAITING_FOR_START');
};

gameController.onFreespinsEndDead = function () {
  gameController.reelsPrize = gameController.preFSReelPrize;
  gameData.winningsMeter.set(gameController.totalWinnings);

  const goldIndicator = resourceManager.get('mainReelsContainer:goldRespin:goldPigText');
  goldIndicator.renderable = true;

  gameController.currentPersistentState = gameController.getPersistentValues(gameController.getCurrentModeStake());
  gameController.updateCounterState(resourceManager.getController('stakeController').getCurrentStake());
  gameController.updateCountersAfterFreeSpins(gameController.getCurrentPersistentStateData());
};

gameController.onFeatureStart = function (task) {};

gameController.globalHelperGetStake = function () {
  let stake = gameData.stakes[gameData.currentStakeIndex];
  if (gameController.buyBonusHigh) {
    stake = gameData.bonusBuyStake * gameController.buyBonusCostFreeSpinsHigh;
  } else if (gameController.buyBonusMystery) {
    stake = gameData.bonusBuyStake * gameController.buyBonusCostFreeSpinsMystery;
  } else if (gameController.buyBonusLow) {
    stake = gameData.bonusBuyStake * gameController.buyBonusCostFreeSpinsLow;
  } else if (gameData.currentStakeIndex === -1) {
    stake = gameController.currentStake;
  }

  return stake;
};

//NOTE: Check Bison Wilds on this
gameController.recoverGame = function (task) {
  // Get stake controller and recovery stake data
  let stakeController = resourceManager.getController('stakeController');
  let recoveryFullStake = gameData.recoveryStake;
  let recoveryWinlineCount = stakeController.CurrentWinLineCount;

  // Recovery game with encore
  if (task.data.metaData === 'encore') {
    gameData.encoreEnabled = task.data.metaValue;
    // recoveryFullStake /= 1.5;
    // recoveryFullStake *= 10;
    stakeController.requestChangeStake(recoveryFullStake / 1.5);
    gameData.stakeMeter.set(recoveryFullStake);

    // Put button in the right state if not already true
    var encoreButtonLB = resourceManager.get('backgroundButtons:luckyBetToggleButton');
    encoreButtonLB.setRecovery();
  }

  gameController.inRecovery = true;
  gameController.tempIgnoreUpdateCountersBecauseOfRestore = true;

  if (task.data.metaData === 'buyABonusFreeSpinsLow' && task.data.metaValue) {
    gameData.bonusBuyStake = recoveryFullStake;
    stakeController.requestChangeStake(recoveryFullStake, 'BONUS_BUY_LOW');
    gameData.stakeMeter.set(recoveryFullStake);
    gameController.inBuyABonus = true;
    gameController.buyBonusLow = true;
    gameController.updateCounters(gameController.getCurrentPersistentStateData(recoveryFullStake));
    gameController.initNewSpin(true);
  } else if (task.data.metaData === 'buyABonusFreeSpinsHigh' && task.data.metaValue) {
    gameData.bonusBuyStake = recoveryFullStake;
    stakeController.requestChangeStake(recoveryFullStake, 'BONUS_BUY_HIGH');
    gameData.stakeMeter.set(recoveryFullStake);
    gameController.inBuyABonus = true;
    gameController.buyBonusHigh = true;
    gameController.updateCounters(gameController.getCurrentPersistentStateData(recoveryFullStake));
    gameController.initNewSpin(true);
  } else if (task.data.metaData === 'buyABonusFreeSpinsMystery' && task.data.metaValue) {
    gameData.bonusBuyStake = recoveryFullStake;
    stakeController.requestChangeStake(recoveryFullStake, 'BONUS_BUY_MYSTERY');
    gameData.stakeMeter.set(recoveryFullStake);
    gameController.inBuyABonus = true;
    gameController.buyBonusMystery = true;
    gameController.updateCounters(gameController.getCurrentPersistentStateData(recoveryFullStake));
    gameController.initNewSpin(true);
  } else {
    musicManager.onGameStart();
    gameController.initNewSpin();

    let baseStake = stakeController.BaseStake;
    let bpl = stakeController.BaseStake / recoveryWinlineCount;
    let luckyBetEnabled = gameData.encoreEnabled;

    stakeController.setStakeMultiplier(luckyBetEnabled ? 1.5 : 1);
    game.changeStake(baseStake * (luckyBetEnabled ? 1.5 : 1), bpl);
    gameData.stakeMeter.set(recoveryFullStake);
    stakeController.broadcastCurrentStake();
  }

  gameController.currentPersistentState = gameController.getPersistentValues(gameController.getCurrentModeStake());
  gameController.updateCounterState(stakeController.getCurrentStake());
  gameController.updateCounters(gameController.getCurrentPersistentStateData());
};

gameController.onAbortGame = function () {
  musicManager.stopSpinButtonSound();
  // if (gameController.currentReelSpin !== undefined) soundManager.stop(gameController.currentReelSpin);

  gameController.slotMachine.abortSpin();

  Loader.setStartingSymbols();
};

gameController.replayComplete = function () {
  gameController.cyclingWins = true;
  gameController.cycleWins();
};

gameController.onOrientationChange = function (landscape) {
  let autoPlayButtonVisibility = resourceManager.get('buttonContainer:buttonBar:autoplayButton').visible;
  if (!autoPlayButtonVisibility) {
    resourceManager.get('buttonContainer:buttonBar:autoplayButton:glow').visible = false;
  }

  console.log('gameController.onOrientationChange');
  // any tweens that we need to finish early because of rotation?
  if (
    gameController.jackpotTrailCoinScaleTween &&
    (gameController.jackpotTrailCoinScaleTween.isActive() ||
      gameController.jackpotTrailCoinScaleTween.time() < gameController.jackpotTrailCoinScaleTween.startTime())
  ) {
    gameController.jackpotTrailCoinScaleTween.totalProgress(1);
  }

  if (
    gameController.jackpotTrailCoinMoveTween &&
    (gameController.jackpotTrailCoinMoveTween.isActive() ||
      gameController.jackpotTrailCoinMoveTween.time() < gameController.jackpotTrailCoinMoveTween.startTime())
  ) {
    gameController.jackpotTrailCoinMoveTween.totalProgress(1);
  }

  gameController.skipMovingCoinsToJackpotPanels();
};

gameController.onLayoutChange = function () {
  let layout = layoutController.getCurrentLayout();

  if (layout === 'portrait_mobile' || layout === 'portrait_default') {
    gameController.portraitMode = true;
  } else {
    gameController.portraitMode = false;
  }

  if (layout === 'landscape_mobile' || layout === 'portrait_mobile') {
    gameController.mobileMode = true;
  } else {
    gameController.mobileMode = false;
  }

  if (gameController.gameLoaded) {
    const freespinsMeter = resourceManager.get('freeSpinsMeter');
    const title = resourceManager.get('title');
    if (freespinsMeter && freespinsMeter.visible === true && title) {
      if (gameController.portraitMode === true) {
        title.renderable = false;
      } else {
        title.renderable = true;
      }
    }
  }
};

gameController.onModal = function (event) {
  if (event.reason && event.reason !== '') {
    if (event.reason === 'Platform Paused') {
      gameController.cancelAutoplay();
      gameController.platformPaused = true;
    } else if (event.data && event.data === 'Platform Popup Open') {
      gameController.platformPopupActive = true;
    }
  } else if (event.data) {
    if (event.data === 'Platform Popup Close' && !gameController.platformPaused) {
      gameController.platformPopupActive = false;
    } else if (event.data === 'Platform Resume') {
      gameController.platformPaused = false;
    }

    if (gameController.platformPopupActive || gameController.platformPaused) {
      messageBus.post('game:modal', { reason: 'Keep locked', data: 'Keep locked' });
    }
  }
};

gameController.getSymbolsOnReel = function (reel, symId) {
  let symbols = [];
  let tempSymbols = gameController.spinTask.data.resultPanel.reelList[reel].symbols;

  for (let row = 0; row < tempSymbols.length; row++) {
    if (tempSymbols[row].value === symId) {
      symbols.push({ reel: reel, row: row });
    }
  }
  return symbols;
};

gameController.getSymbolsOnReels = function (symId) {
  let symbols = [];

  for (let reel = 0; reel < gameController.spinTask.data.resultPanel.reelList.length; reel++) {
    for (let row = 0; row < gameController.spinTask.data.resultPanel.reelList[reel].symbols.length; row++) {
      if (gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value === symId) {
        symbols.push({ reel: reel, row: row });
      }
    }
  }

  return symbols;
};

gameController.playLandAnims = function (symbols, symbolId) {
  if (gameController.slamStopped) return;

  let symbolsToAnimate = [];

  for (let i = 0; i < symbols.length; i++) {
    let symData = {
      cell: { reel: symbols[i].reel, row: symbols[i].row },
      symbolId: symbolId,
    };
    symbolsToAnimate.push(symData);
  }
  if (symbolsToAnimate.length > 0) {
    // gameController.symbolLandAnimator.animateSymbols(
    //   symbolsToAnimate,
    //   gameController.slotMachine,
    //   true,
    //   false,
    //   undefined
    // );
  }
};

gameController.playSingleLandAnim = function (reel, row, symbolId, callback) {
  if (gameController.slamStopped) return;

  let symbolsToAnimate = [];
  let symData = {
    cell: { reel: reel, row: row },
    symbolId: symbolId,
  };
  symbolsToAnimate.push(symData);

  // gameController.symbolLandAnimator.animateSymbols(symbolsToAnimate, gameController.slotMachine, true, false, callback);
};

gameController.playBonusAnims = function (symbols, symbolId, isInitial = true) {
  let symbolsToAnimate = [];

  for (let i = 0; i < symbols.length; i++) {
    let symData = {
      cell: { reel: symbols[i].reel, row: symbols[i].row },
      symbolId: symbolId,
    };
    symbolsToAnimate.push(symData);
  }
  // gameController.symbolLandAnimator.skip();
  gameController.symbolAnimator.animateSymbols(symbolsToAnimate, gameController.slotMachine, true, false, undefined);
};

gameController.loopBonusAnim = function (symbols, symbolId, loopCount, delay, callback) {
  if (loopCount > 0) {
    gameController.playBonusAnims(symbols, symbolId);
    loopCount--;
    timerManager.addTimeout(delay, () => {
      gameController.loopBonusAnim(symbols, symbolId, loopCount, delay, callback);
    });
  } else {
    if (callback) {
      callback();
    }
  }
};

gameController.getCurrentMode = function () {
  let mode;
  if (gameController.buyBonusMystery) {
    mode = 'BONUS_BUY_MYSTERY';
  } else if (gameController.buyBonusLow) {
    mode = 'BONUS_BUY_LOW';
  } else if (gameController.buyBonusHigh) {
    mode = 'BONUS_BUY_HIGH';
  } else if (gameData.encoreEnabled) {
    mode = 'GOLDENBET_BUY';
  } else {
    mode = 'BASIC';
  }
  return mode;
};

gameController.dimFullReel = function (reel, dim, time = 0) {
  let symbolsToDim = [];

  for (let j = 0; j < 7; ++j) {
    symbolsToDim.push({ reel: reel, row: j });
  }
  gameController.slotMachine.dimSymbols(symbolsToDim, dim, time);
  gameController.symbolOverlayDisplay.dimSymbols(symbolsToDim, dim, time);
};

gameController.swapToPreBonusReels = function () {
  gameController.symbolOverlayDisplay.hideAllBonusOverlays();

  for (let reel = 0; reel < gameController.bonusTriggeringReels.length; reel++) {
    let reelContainer = resourceManager.get('mainReelsContainer:slotContainer:reelContainer:reel' + reel);
    for (let row = 0; row < gameController.bonusTriggeringReels[reel].length; row++) {
      let symId = gameController.bonusTriggeringReels[reel][row];
      reelContainer.setReelSymbol(row, symId);
    }
  }
};

gameController.addAnticipationSymbols = function (reelHit, symId) {
  if (!gameController.anticpationSymbolsAddedThisSpin && reelHit < 5) {
    if (symId === 15) {
      reelHit = 4;
    }

    let anticipationReelCount = 0;
    let minGap = 4;

    for (let i = reelHit + 1; i < 6; i++) {
      let symCount = 1;
      if (symId === 14) {
      } else if (symId === 15) {
        symCount = gameController.getRandomRange(1, 2);
        minGap = 10;

        let anticipationSymbols = {
          reel: i,
          symId: symId,
          count: symCount,
          minGap: minGap,
        };
        gameController.slotMachine.insertAnticipationSymbols(anticipationSymbols);
      }

      anticipationReelCount++;
    }
    gameController.anticpationSymbolsAddedThisSpin = true;
  }
};

gameController.getRandomRange = function (min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

gameController.setBonusWheelVisible = function (visible) {
  gameController.bonusWheelVisible = visible;
};

gameController.globalHelperGetBaseStake = function () {
  if (!gameController.gameLoaded) {
    return;
  }

  const stake = resourceManager.getController('stakeController').getBaseStake();

  return stake;
};

gameController.skipPiggyAnims = function () {
  console.log('SKIP: gameController.skipPiggyAnims skipping anims');
  gameController.skipCurrentPiggieAnims = true;

  pigSpineController.skipAllCurrentAnims();

  // stop any coins going from blue pig to jackpot panels
  gameController.skipMovingCoinsToJackpotPanels();

  // we need to tell any existing coins to pig anims to finish
  gameController.skipMovingCoinsToPigsTweens();
};

gameController.resetGoldPigAfterWheelPresentation = function (task) {
  gameController.skipCurrentPiggieAnims = false;
  const goldIndicator = resourceManager.get('mainReelsContainer:goldRespin:goldPigText');
  if (goldIndicator) {
    goldIndicator.setText(task.data.gameDisplayStateAfterPart.numWheelUpgrades);
  }

  if (task.data.didDeliverFeatures === true) {
    // we are going into free spins, shouldnt need to do anything with the size of the pig
  } else {
    // not going into free spins
    // use the reset function to make sure the pig is at the right size
    gameController.resetPigsAfterFreeSpins({
      gold: task.data.gameDisplayStateAfterPart.wheelDisplayLevelIndex,
    });
  }
};

gameController.onGameSkipped = function (stakeInfo) {
  if (gameData.recoveryMode === 'GOLDENBET_BUY' || !gameData.recoveryMode) {
    // we dont need to worry about this for GOLDENBET or normal
  } else {
    // we make the meter show the correct stake on a restore, but nothing seems to set the stake controller up correctly if you press skip
    // so we have a new message and we do that here
    // ideally this should be in the libs somewhere!!

    const stakeController = resourceManager.getController('stakeController');

    // now we can have bonus buys on different stakes compared to normal
    // os 1st lets make sure the stake is valid for BASIC
    const stakeIndex = stakeController.Stakes.indexOf(stakeInfo.baseStake);
    if (stakeIndex === -1) {
      // the bonus buy stake isnt in the BASIC stake
      // so we need to use the default
      // this is assuming default stake has been set correctly :( as everything appears to be in closures!!
      stakeInfo.baseStake = stakeController.BaseStake;
    }

    stakeController.requestChangeStake(stakeInfo.baseStake);

    // trust me bro!
    gameData.stakeMeter.set(stakeInfo.baseStake);
  }
};

function RNG() {
  const m = 0x80000000;
  const a = 1664525;
  const c = 1013904223;

  let state;

  this.seed = function (newSeed) {
    let seedToUse = newSeed;

    if (typeof newSeed === 'string') {
      let hash = 0;
      for (let i = 0; i < newSeed.length; i++) {
        hash = newSeed.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
      }
      seedToUse = Math.abs(hash);
    }
    state = seedToUse ? seedToUse : 0;
  };

  this.seed(0);

  this.nextInt = function () {
    state = (a * state + c) % m;
    return state;
  };

  this.nextFloat = function () {
    return this.nextInt() / (m - 1);
  };
}

Reflex.addToUpdate(gameController.update);
messageBus.subscribe('common:GameSkipped', gameController.onGameSkipped);
messageBus.subscribe('spinner:GameConfigEvent', gameController.onLayoutComplete);
messageBus.subscribe('spinner:SpinEvent', gameController.doSpin);
messageBus.subscribe('autoplay:started', gameController.autoplayStarted);
messageBus.subscribe('autoplay:ended', gameController.autoplayEnded);
messageBus.subscribe('stake:stakeChanged', gameController.onStakeChanged);
messageBus.subscribe('common:RecoverGame', gameController.recoverGame);
messageBus.subscribe('common:GameCompleteEvent', gameController.onGameComplete);
messageBus.subscribe('spinner:WinningLinesEvent', gameController.doPayWins);
messageBus.subscribe('game:FeatureAnnounceEvent', gameController.onFeatureStart);
messageBus.subscribe('spinner:FreeSpinsStartEvent', gameController.onFreespinsStart);
messageBus.subscribe('spinner:FreeSpinsEndEvent', gameController.onFreespinsEnd);
messageBus.subscribe('spinner:FreeSpinsEndEventDead', gameController.onFreespinsEndDead);
messageBus.subscribe('common:AbortGame', gameController.onAbortGame);
messageBus.subscribe('platform:ReplayComplete', gameController.replayComplete);
messageBus.subscribe('game:restoreCountersEvent', gameController.restoreCounters);
messageBus.subscribe('game:updatePersistentValuesEvent', gameController.onPersistentValuesUpdate);
messageBus.subscribe('game:updatePiggiesBecauseOfForceEvent', gameController.onUpdatePiggiesBecauseOfForceEvent);
messageBus.subscribe('game:buyBonusLowActive', gameController.onBuyBonusLowActive);
messageBus.subscribe('game:buyBonusHighActive', gameController.onBuyBonusHighActive);
messageBus.subscribe('game:buyBonusMysteryActive', gameController.onBuyBonusMysteryActive);
//messageBus.subscribe('game:FeatureAwardEvent', gameController.doFeatureAwarded);
messageBus.subscribe('feature:buyBonusWheelDead', (task) => {
  gameController.resetGoldPigAfterWheelPresentation(task);
});
messageBus.subscribe('feature:wheelDead', (task) => {
  gameController.resetGoldPigAfterWheelPresentation(task);
});

Reflex.registerEventHandler('layoutChange', gameController.onLayoutChange);
messageBus.subscribe('game:modal', gameController.onModal);
